<template>
  <div>
    <title>打印列表</title>
    <section class="orderSect">
      <!--S 检索-->
      <el-form :model="printFormInline" inline>
        <el-form-item label="面单类型" v-show="printType=='1000'" required>
          <el-select v-model="printFormInline.expressWay" filterable placeholder="请选择或输入" clearable>
            <el-option v-for="(item,index) in expressWayList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递类型" v-show="printType=='110'" required>
          <el-select v-model="printFormInline.expmodeofcn" filterable placeholder="请选择或输入" clearable
            @change="selectExpmode">
            <el-option v-for="(item,index) in expmodelistOfCn" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="寄件地址" v-show="printType=='110' && sendAddrList.length > 0" required>
          <el-select v-model="printFormInline.sendAddr" filterable placeholder="请选择或输入" clearable>
            <el-option v-for="(item,index) in sendAddrList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务类型"
          v-show="printType=='110' && printFormInline.expmodeofcn == '100' && serviceList.length > 0">
          <el-select v-model="printFormInline.attrCode" filterable placeholder="请选择或输入" clearable
            @change="selectServer">
            <el-option v-for="(item,index) in serviceList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="attrTitle" v-show="printType=='110' && printFormInline.attrCode && attrNumber">
          <el-input type="number" v-model="printFormInline.attrNumber" clearable @blur="getAttrValue"></el-input>
        </el-form-item>
        <el-form-item :label="attrTitle" v-show="printType=='110' && printFormInline.attrCode && attrString" required>
          <el-input v-model="printFormInline.attrString" clearable></el-input>
        </el-form-item>
        <el-form-item :label="attrTitle" v-show="printType=='110' && printFormInline.attrCode && attrOpt" required>
          <el-select v-model="printFormInline.attrEnum" filterable placeholder="请选择或输入" clearable>
            <el-option v-for="(item,index) in attrOptList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打印序号" required>
          <span class="flexUI serialIpt">
            <el-input type="number" v-model="printFormInline.startSerial" @blur="checkSerial(0)"></el-input>
            <i>~</i>
            <el-input type="number" v-model="printFormInline.endSerial" @blur="checkSerial(1)"></el-input>
            <i class="iconwh" v-popover:serialPop></i>
            <el-popover placement="top" width="220" trigger="hover" ref="serialPop">
              <p class="greyColor">参照下方的数据列表区输入序号。<em class="redColor"
                  v-show="printType=='90'">(京东热敏一次下单不能超过100个快递，可输入打印序号来调整一次下单的数量。)</em></p>
            </el-popover>
          </span>
        </el-form-item>
        <el-form-item>
          <el-button v-show="expmerge&&breturn!=1" type="primary" plain @click="CombinedExpress(1)">合并勾选快递</el-button>
          <el-button v-show="expmerge&&breturn!=1" type="primary" plain @click="CombinedExpress(0)">一键合并快递</el-button>
          <el-button type="primary" plain @click="phoneTableSort()">按电话排序</el-button>
        </el-form-item>
        <el-form-item v-if="printType=='1000'">
          <el-button type="primary" plain @click="orderCollection()">单号采集</el-button>
          <el-button type="primary" plain @click="printMaintenance()">打印维护</el-button>
          <el-button type="primary" plain @click="sheetPrint()">面单打印</el-button>
        </el-form-item>
        <el-form-item v-else>
          <el-button v-if="((printType == '1' && printconfig.sfbzmj == 1) || printType == '90')&&breturn!=1"
            v-show="!setStatus" type="primary" plain @click="setPknum(0)">批量设置包裹数</el-button>
          <el-popover placement="bottom"
            v-if="((printType == '1' && printconfig.sfbzmj == 1) || printType == '90')&&breturn!=1" trigger="hover"
            ref="setPackagePop">
            <p class="greyColor">为多个快递同时设置快递包裹数量（包裹数量大于1为子母单）</p>
            <i class="iconwh" slot="reference" v-show="!setStatus"></i>
          </el-popover>
          <el-button type="danger" v-show="setStatus" icon="el-icon-close" round
            @click="confirmCancel(0)">取消</el-button>
          <el-button type="success" v-show="setStatus" icon="el-icon-check" round
            @click="confirmCancel(1)">确定</el-button>

          <el-button type="primary" plain @click="subOrder()" v-if="breturn!=1">下单</el-button>
          <el-button type="primary" v-if="printType=='97'&&breturn!=1" plain @click="subOrder(3)">下单（需转单）</el-button>
          <el-button type="primary" plain @click="subPrint()">打印</el-button>
          <el-button type="primary" v-if="qydm == '9998' && printType=='90'" plain
            @click="jdPrintOfVirtual()">模拟打印</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->

      <!--S 快递打印列表-->
      <div class="allOrderTab individualiz">
        <el-form :model="printFormInline" inline size="medium">
          <el-form-item class="borderline">
            <em class="greyColor">订单号</em>
            <el-input v-model="printFormInline.orderno" placeholder="请输入订单号" clearable></el-input>
          </el-form-item>
          <el-form-item class="borderline">
            <em class="greyColor">打印状态</em>
            <el-checkbox-group v-model="printFormInline.printStatus">
              <el-checkbox v-for="(item,index) of PrintStatusLists" :label="item.value" :key="index"
                v-on:change="sourceChange($event,item)">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline borderNone">
            <el-checkbox v-model="orderContProp">按快递内容排序</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getPrintList">查询</el-button>
            <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="printListData" ref="expressTable" class="orderTable comTable" border
          :maxHeight="tableHeight" @sort-change="changeTableSort">
          <el-table-column width="80" fixed>
            <template slot="header" slot-scope="scope">
              <el-checkbox v-model="allSelect" :title="scope.blank" @change="allCheckedChange"></el-checkbox>
            </template>
            <template slot-scope="scope" v-if="disTable(scope.row)">
              <template>
                <el-checkbox-group v-model="multipleSelection" @change="handleSelectionChange" class="hideLable">
                  <el-checkbox :label="scope.row"></el-checkbox>
                </el-checkbox-group>
              </template>
            </template>
          </el-table-column>
          <!-- <el-table-column type="selection" fixed :selectable="disTable"></el-table-column> -->
          <el-table-column type="index" fixed label="序号"></el-table-column>
          <el-table-column v-if="printType=='1000'" fixed label="对照码" prop="expid" sortable min-width="120">
            <template slot-scope="scope">
              <p>{{scope.row.expid}}</p>
            </template>
          </el-table-column>
          <div v-else>
            <el-table-column label="筛单状态" prop="screenstate" sortable>
              <template slot-scope="scope">
                <span :class="scope.row.screenstate | screenStateColorFilter">{{scope.row.screenstate | screenStateFilter}}</span>
              </template>
            </el-table-column>
            <el-table-column label="下单类型" prop="handletype" sortable>
              <template slot-scope="scope">
                <span>{{scope.row.handletype | handleTypeFilter}}</span>
              </template>
            </el-table-column>
          </div>
          <el-table-column label="快递内容" width="350" prop="expcontent" sortable min-width="250">
            <template slot-scope="scope">
              <small>订单号：{{scope.row.eorderno ? scope.row.eorderno : scope.row.orderno}}</small>
              <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
            </template>
          </el-table-column>
          <el-table-column v-if="(printType == '1' && printconfig.sfbzmj == 1) || printType == '90'" label="包裹数"
            width="100" prop="packagenum" sortable>
            <template slot-scope="scope">
              <el-input v-if="!scope.row.expno" type="number" maxlength="2" v-model="scope.row.packagenum"
                @focus="setOldPknum(scope.row.packagenum)" @blur="changePknum(scope.row)"></el-input>
              <span v-else>{{scope.row.packagenum || 1}}</span>
            </template>
          </el-table-column>
          <el-table-column label="收货信息" width="350" prop="fulladdr" sortable min-width="250">
            <template slot-scope="scope">
              <div class="shouMsg">
                <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
                <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
              </div>
              <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="发货状态" prop="deliverstate" sortable>
            <template slot-scope="scope">
              <span
                :class="[{'blueColor':scope.row.deliverstate==1 || scope.row.deliverstate==3},{'orangeColor':scope.row.deliverstate==0},{'redColor':scope.row.deliverstate==2 || scope.row.deliverstate==6},{'greyColor':scope.row.deliverstate==4},{'greenColor':scope.row.deliverstate==5}]">{{scope.row.deliverstate
                | deliverStateFilter}}</span>
            </template>
          </el-table-column>
          <el-table-column label="打印状态" prop="bprint" sortable>
            <template slot-scope="scope">
              <span :class="[{'orangeColor':scope.row.bprint==0},{'blueColor':scope.row.bprint==1}]"
                v-if="scope.row.bprint == 0">待打印</span>
              <span :class="[{'orangeColor':scope.row.bprint==0},{'blueColor':scope.row.bprint==1}]"
                v-if="scope.row.bprint == 1">已打印</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="(printType=='90' &&qydm == '9998')?180:100">
            <template slot-scope="scope">
              <span class="blueColor" :title="scope.row.bank" @click="viewDetail(scope.row.expcode)">详情</span>
              <span class="blueColor" v-if="qydm == '9998' && printType=='90'" :title="scope.row.bank"
                @click="subJdOrderOfVirtual(scope.row.expcode)">模拟下单</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
      </div>
      <!--S 快递打印列表-->
    </section>

    <!--S 下单操作选择寄件方-->
    <el-dialog :visible.sync="senderShow" class="comDlog senderMdg" :before-close="closeSenderBox"
      :close-on-click-modal="false" append-to-body>
      <div slot="title" class="dialog-title">批量打印</div>
      <el-form label-width="180px" v-loading="subLoading">
        <!-- 顺丰快递类型 -->
        <el-form-item v-if="printType == '1' && printconfig.ordercanchange != 0" label="顺丰快件产品类别">
          <el-select v-model="sfexpresstype" filterable clearable placeholder="请选择">
            <el-option v-for="item in sfexpresstypeList" :key="item.productcode" :label="item.description"
              :value="item.productcode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="printType == '107'" label="店铺">
          <el-select v-model="entity" @change="selectShop" filterable clearable placeholder="请选择">
            <el-option v-for="item in shopArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="entity && printType == '107'" label="仓库">
          <el-select v-model="store" filterable clearable placeholder="请选择">
            <el-option v-for="item in storesArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品类型" v-if="printType == '90' && printconfig.odcanchangeprotype == 1">
          <el-select v-model="promisetimetype" filterable clearable placeholder="请选择">
            <el-option v-for="item in promisetimetypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="京东配送产品类型" v-if="printType == '90' && printconfig.odcanchangegoodstype == 1">
          <el-select v-model="jdgoodstype" filterable clearable placeholder="请选择">
            <el-option v-for="item in jdgoodstypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!--S 寄件方下拉组件-->
        <SenderSelect :senderInit="senderShow" @senderObtain="senderReceive"></SenderSelect>
        <!--E 寄件方下拉组件-->
        <el-form-item label="上门取件时间" v-if="printconfig&&printconfig.openPickupTime==1">
          <el-popover v-model="calendarpanel" placement="bottom-start" width="340" popper-class="calendarPnl">
            <p class="panelTit flexBet">
              <span v-for="(item,index) in canselDayList" :key="index" :class="{'on':currentDayIndex == index}"
                @click="changeSelDay(item,index)">{{item.day}}<br>{{item.date}}</span>
            </p>
            <ul class="panelUBox">
              <li v-for="(item,index) in activeDayItem.pickupTimeRangeList" :key="index"
                :class="{'on':selectedtime == activeDayItem.date+' ' +item.pickupStartTime+'-'+item.pickupEndTime}"
                @click="changeSelTime(item,index)">{{item.pickupStartTime}}-{{item.pickupEndTime}}</li>
            </ul>
            <el-input v-model="selectedtime" clearable slot="reference" readonly placeholder="请选择上门时间">
              <template slot="append"><i class="el-icon-date fz20"></i></template>
            </el-input>
          </el-popover>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSenderBox(1)" :loading="subLoading">确定</el-button>
        <el-button @click="closeSenderBox(0)">取消</el-button>
      </div>
    </el-dialog>
    <!--E 下单操作选择寄件方-->

    <!--S 打印面单操作填写对照码-->
    <el-dialog title="确认对照码" :visible.sync="domSheetShow" class="comDlog referMdg" :before-close="closeDomSBox"
      :close-on-click-modal="false" append-to-body>
      <el-form label-width="150px">
        <p class="redColor">请您确认打印成功后，完成本次操作！</p>
        <el-form-item label="最后成功对照码" required>
          <el-input v-model="referenceCode" placeholder="请输入对照码" clearable></el-input>
          <i class="iconwh" v-popover:referPop></i>
          <el-popover placement="top" width="220" trigger="hover" ref="referPop">
            <p class="greyColor">参照快递单上的对照码填写。</p>
          </el-popover>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDomSBox(1)">确定</el-button>
        <el-button @click="closeDomSBox(0)">取消</el-button>
      </div>
    </el-dialog>

    <!-- 批量设置包裹数量 -->
    <el-dialog title="批量设置包裹数量" :visible.sync="setPknumShow" class="comDlog referMdg" :before-close="closePknumBox"
      :close-on-click-modal="false" append-to-body>
      <el-form label-width="150px">
        <el-form-item label="包裹数" required>
          <el-input-number v-model="packagenum" :min="1" :max="100" label="包裹数"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closePknumBox(1)">确定</el-button>
        <el-button @click="closePknumBox(0)">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择打印机" :visible.sync="setPrintShow" class="comDlog referMdg" :before-close="closePrintBox"
      append-to-body :close-on-click-modal="false">
      <el-form label-width="150px">
        <el-form-item label="选择打印机" required>
          <el-select v-model="selectedPrint" filterable placeholder="请选择或输入" clearable>
            <el-option v-for="(item,index) in printList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择面单" required v-show="printType == '90'">
          <el-select v-model="selectedJDTemplate" filterable placeholder="请选择或输入" clearable>
            <el-option v-for="(item,index) in jdTemplateList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closePrintBox(1)" :loading="chosePrintLoding">确定</el-button>
        <el-button @click="closePrintBox(0)">取消</el-button>
      </div>
    </el-dialog>

    <!-- 重复打印提示弹窗 -->
    <el-dialog title="重复打印提示" :visible.sync="printAgainShow" class="comDlog referMdg" :before-close="closeAgainBox"
      :close-on-click-modal="false" append-to-body>
      <el-form label-width="150px">
        <p class="redColor">打印列表中存在已打印快递1份，确定要重复打印吗？</p>
        <el-form-item label="登录密码" required>
          <el-input v-model="pwd" placeholder="请输入登录密码" clearable></el-input>
        </el-form-item>
        <el-form-item label="重复打印备注" required>
          <el-input v-model="repeatmemo" maxlength="30" placeholder="请输入重复打印备注" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeAgainBox(1)">确定</el-button>
        <el-button @click="closeAgainBox(0)">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="系统提示" :visible.sync="referSuccessVisible" class="comDlog referSuccess"
      :before-close="closeReferBox" :close-on-click-modal="false" append-to-body>
      <main class="flexUI referMain">
        <i class="el-icon-success"></i>
        <div class="refrtTxt" v-html="print_result"></div>
      </main>
      <span v-if="this.printType == '1000'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeReferBox(1)">单号采集</el-button>
        <el-button @click="closeReferBox(0)">继续打印</el-button>
      </span>
    </el-dialog>
    <!--E 打印面单操作填写对照码-->

    <!--S 菜鸟控件提示-->
    <el-dialog title="系统提示" :visible.sync="tipCNMsg" class="comDlog cnDlog" :before-close="closeCNBox"
      :close-on-click-modal="false" append-to-body>
      <div>
        <p class="el-icon-warning fz16">抱歉，无法链接到菜鸟打印组件！</p>
        <el-link type="primary" :underline="false" target="_blank"
          href="https://page.cainiao.com/waybill/cloud_printing/home.html">点击此处下载安装
        </el-link>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeCNBox" size="medium">确定</el-button>
      </span>
    </el-dialog>
    <!--E 菜鸟控件提示-->

    <!--S 京东控件提示-->
    <el-dialog title="系统提示" :visible.sync="tipJDMsg" class="comDlog cnDlog" :before-close="closeJDBox"
      :close-on-click-modal="false" append-to-body>
      <div>
        <p class="el-icon-warning fz16">抱歉，无法链接到JD打印组件！</p>
        <el-link type="primary" :underline="false"
          href="http://prod-oms-app-cprt.jdwl.com/OpenCloudPrint/setup.exe">点击此处下载安装
        </el-link>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeJDBox" size="medium">确定</el-button>
      </span>
    </el-dialog>
    <!--E 京东控件提示-->

    <!--S 打印操作完善快递弹窗组件-->
    <ImproveExpress :improveExpressBox="improveShow" :collectedShow="collected" @closeIEVal="clsBtnVal"
      @closeIEBox="closeImproveExpress"></ImproveExpress>
    <!--E 打印操作完善快递弹窗组件-->

    <!--S 快递详情组件-->
    <DeliveryDetail :deliveryDetailBox="expressDetailShow" :expcode="expcode" @closeDDBox="expressDetailShow = false">
    </DeliveryDetail>
    <!--E 快递详情组件-->

    <!--S 顺丰JS外链-->
    <RemoteJs></RemoteJs>
    <!--E 顺丰JS外链-->

    <!--S 打印任务中，禁止操作-->
    <el-dialog class="uploadImg tipDescription" :visible.sync="loadingCover" append-to-body
      :close-on-click-modal="false" :show-close="false" :modal="false">
      <PageLoading :isprint="1"></PageLoading>
      <p>快递打印任务加载中...<br>请耐心等待加载任务完成，期间不要刷新或者关闭当前页面！</p>
    </el-dialog>
    <!--E 打印任务中，禁止操作-->

  </div>
</template>

<script>
  import { Message, MessageBox } from "element-ui"
  import Vue from 'vue'
  import api from '../../apis/api'
  import getLodop from '../../util/LodopFuncs.js'
  import * as print from '../../util/print.js'
  // import * as scprint from '../../util/SCPPrint.js'
  import axios from 'axios'
  export default {
    name: 'AddExpress',
    data() {
      return {
        sysexpparainfoList: '',
        orderContProp: false,//按订单内容排序
        contentsort: 0,//是否按订单内容排序
        setStatus: false,
        setPackageNum: false,//是否批量设置包裹数
        printType: 'needleTypePrinting', //路由打印类型赋值
        sendAddrList: [
        ],//寄件地址列表
        expressWayList: [
        ],//面单类型列表
        PrintStatusLists: [
        ], //打印状态
        serviceList: [
        ],
        attrOptList: [],
        printFormInline: {
          expressWay: '',//面单类型
          sendAddr: '', //寄件地址
          startSerial: '1', //打印起始序号
          endSerial: '20', //打印结束序号
          orderno: "", //订单号
          printStatus: [], //打印状态
        },
        senderShow: false, //寄件方弹窗
        sender: '', //已选寄件方
        senderList: [
          { value: "0", label: "苏州大卖场" },
          { value: "1", label: "大闸蟹门店" },
          { value: "2", label: "上海大卖场" },
        ], //寄件方列表
        printListData: [
        ],//打印列表数据
        printList: [],//打印机列表
        expmodelistOfCn: [],//菜鸟快递类型
        allSelect: false,//表格全选
        multipleSelection: [], //已选中的行
        tableHeight: window.innerHeight * 0.8, //表格动态高度
        expressDetailShow: false, //快递详情
        improveShow: false, //完善快递的弹窗
        improveEprBtnVal: '',//关闭完善快递弹窗是确定还是取消
        collected: false,//是否展示快递方式
        referenceCode: '', //对照码
        domSheetShow: false, //面单打印弹窗
        setPknumShow: false,//批量设置包裹数弹窗
        setPrintShow: false,//选择打印机弹窗
        printAgainShow: false,//重复打印弹窗
        oldPknum: 1,//修改前的包裹数量
        packagenum: 1,//批量设置的包裹数
        pwd: '',//登录密码
        referSuccessVisible: false, //打印成功
        descending: false,//电话排序降序
        tipCNMsg: false, //菜鸟控件提示
        expgenbatchnoArr: '',//批次编号
        expcode: '',//快递编号
        loading: true,//加载遮罩
        expcodeArr: [],//已经选中的快递编号
        expmerge: 0,//是否包含可合并快递 0 否 1 是
        orderbytel: 0,//按电话排序 0否 1是
        deliverstate: '',//筛单状态
        bprint: '',//打印状态
        printInfo: {
          element: '',//快递单内容
          fontsize: '',//字号
          fontfamily: '',//字体
          wordspace: '',//字间距
          lineheight: '',//行距
          toffset: '',//偏移：上
          loffset: '',//偏移：左
          wpagesize: '',//尺寸：宽
          hpagesize: '',//尺寸：高
          bgurl: '',//背景图片
        },//面单元素
        P_ID: '',//打印任务
        senderid: '',//默认寄件方id
        senderInfo: {},//默认寄件方信息
        exptype: '',//快递方式标识
        finishParam: {
          startNo: '',//起始序号
          endNo: '',//结束序号
          printType: '',//快递处理方式
          exptype: '',//快递方式，默认打印（针式打印）时必填
          dzm: '',//对照码，默认打印（针式打印）时必填
          taskValues: '',//未加入打印任务队列的序号（多个以英文逗号分隔）
          mark: '',//快递标识
          expmoney: '',//快递费用
          issend: '',//快递通知 ： 1：开启；0： 关闭；
          sendMsgDate: '',//短信通知日期 yyyy-MM-dd
        },//打印完成参数
        printconfig: '',//打印方式配置
        addrId: '',//寄件地址，handletype=110时必填
        mark: '',//快递标识，handletype=110时必填
        attrValue: '',//菜鸟拼接参数，handletype=110时必填
        store: '',//仓库编号，handletype=107时必填
        entity: '',//店铺编码，handletype=107时必填
        screenstate: '',//筛单状态，0：待筛单；1：筛单处理成功；2：筛单处理失败
        repeatmemo: '',//重复打印备注
        expmoney: '',//快递费用
        issend: 0,//是否发送短信
        sendMsgDate: '',//发送短信日期
        attrTitle: '服务内容',
        attrNumber: '',//金额数字类服务内容
        attrString: '',//字符类服务内容
        attrOpt: '',//下拉选择类服务内容
        openPrintersFlag: false,//菜鸟打印
        selectedPrint: '',//选中的打印机
        webSocket: '',
        print_result: '打印成功',//打印成功提示
        cnParams: {
          verson: "1.0",
          cmd_getPrinters: "getPrinters",
          cmd_setPrinterConfig: "setPrinterConfig",
          cmd_print: "print",
          printTaskId: '',
          defaultPrinter: '',
          printFlag: false,
          isdialog: false,
        },//菜鸟参数
        ydPrintData: '',//韵达初始化内容
        ydServiceUrl: 'http://127.0.0.1:9090/ydecx/service/mailpx/printDirect.pdf?tname=mailtmp_s12&docname=mailpdfm1&t=',//韵达服务地址
        sfexpresstype: "",
        storesArr: [],//京东云仓
        shopArray: [],//京东云仓店铺列表
        sfexpresstypeList: [//快件产品类别 可用
          // {
          //   value: '1',
          //   label: '顺丰标快'
          // }, {
          //   value: '2',
          //   label: '顺丰标快（陆运）'
          // },{
          //   value: '5',
          //   label: '顺丰次晨'
          // }, {
          //   value: '6',
          //   label: '顺丰即日'
          // }, {
          //   value: '9',
          //   label: '国际小包平邮'
          // }, {
          //   value: '10',
          //   label: '国际小包挂号'
          // }, {
          //   value: '23',
          //   label: '顺丰国际特惠(文件)'
          // }, {
          //   value: '29',
          //   label: '国际电商专递-标准'
          // }, {
          //   value: '31',
          //   label: '便利封/袋(标快)'
          // }, {
          //   value: '33',
          //   label: '岛内件(80CM)'
          // }, {
          //   value: '53',
          //   label: '高铁站配'
          // },{
          //   value: '111',
          //   label: '顺丰特惠D'
          // }, {
          //   value: '112',
          //   label: '顺丰空配'
          // },{
          //   value: '153',
          //   label: '整车直达'
          // }, {
          //   value: '154',
          //   label: '重货包裹'
          // }, {
          //   value: '155',
          //   label: '标准零担'
          // }, {
          //   value: '174',
          //   label: '重货包裹B'
          // }, {
          //   value: '199',
          //   label: '极速包裹'
          // }, {
          //   value: '201',
          //   label: '冷运标快'
          // }, {
          //   value: '202',
          //   label: '顺丰微小件'
          // },{
          //   value: '208',
          //   label: '特惠专配'
          // },{
          //   value: '209',
          //   label: '高铁专送'
          // }, {
          //   value: '215',
          //   label: '大票直送'
          // }, {
          //   value: '221',
          //   label: '香港冷运到家(≤60厘米)'
          // }, {
          //   value: '229',
          //   label: '精温专递'
          // }, {
          //   value: '231',
          //   label: '陆运包裹'
          // }, {
          //   value: '233',
          //   label: '精温专递(样本陆)'
          // }, {
          //   value: '234',
          //   label: '商务标快'
          // }, {
          //   value: '235',
          //   label: '极效前置'
          // }, {
          //   value: '238',
          //   label: '纯重特配'
          // }, {
          //   value: '242',
          //   label: '丰网速运'
          // }, {
          //   value: '243',
          //   label: '同城即日'
          // }, {
          //   value: '247',
          //   label: '电商标快'
          // }
        ],
        allSfexpresstypeList: [], //快件产品类别 所有的

        //-----------------限制上门时间-------------
        selectedtime: '',//上门取件时间
        calendarpanel: false,//日历面板
        canselDayList: [],
        activeDayItem: {},//选中的天
        currentDayIndex: 0,//选中的天索引
        currentTimeIndex: -1,//选中的时间段索引
        pickupStartTime: '',
        pickupEndTime: '',
        subLoading: false, // 下单遮罩
        breturn: 0, // 是否为重置待发进入 1为是
        promisetimetype: '', // 京东产品类型
        promisetimetypeList: [
          {
            value: '1',
            label: '特惠送'
          }, {
            value: '2',
            label: '特快送'
          }, {
            value: '4',
            label: '城际闪送'
          }, {
            value: '7',
            label: '微小件'
          }, {
            value: '8',
            label: '生鲜专送'
          }, {
            value: '16',
            label: '生鲜特快'
          }, {
            value: '17',
            label: '生鲜特惠'
          }, {
            value: '20',
            label: '函速达'
          }, {
            value: '21',
            label: '特惠包裹'
          }
        ], // 京东产品类型列表
        jdgoodstype: '', // 京东配送产品类型
        jdgoodstypeList: [
          {
            value: '1',
            label: '普通'
          }, {
            value: '2',
            label: '生鲜常温'
          }, {
            value: '3',
            label: '填仓'
          }, {
            value: '4',
            label: '特配'
          }, {
            value: '5',
            label: '鲜活'
          }, {
            value: '6',
            label: '控温'
          }, {
            value: '7',
            label: '冷藏'
          }, {
            value: '8',
            label: '冷冻'
          }, {
            value: '9',
            label: '深冷'
          }
        ], // 京东配送产品类型列表

        printSdk: null,
        printer: null,
        sftoken: '',
        printers: [],
        checkcode: 'JHTRJmvvE0Jk', //这个是写死的，用的我们自己的

        jdWebSocket: null,
        tipJDMsg: false,
        selectedJDTemplate: '',
        jdTemplateList: [],
        jdsuccessnum: 0,//打印成功数量
        jdallnum: 0,//共打印数量
        jdcpcodes: new Map(),//京东模板cpcode
        jdprinttest: false,//京东打印测试
        qydm: '',
        chosePrintLoding: false,//选择打印机按钮遮罩
        loadingCover: false,//打印中勿动的遮罩
      }
    },
    components: {
      DeliveryDetail: resolve => require(["@/components/common/DeliveryDetail.vue"], resolve), //快递详情组件
      ImproveExpress: resolve => require(["@/components/DeliveryFolder/ImproveExpress.vue"], resolve), //完善快递组件
      SenderSelect: resolve => require(["@/components/common/SenderSelect.vue"], resolve),// 寄件方下拉组件
      'RemoteJs': {
        render(createElement) {
          return createElement(
            'script',
            {
              attrs: {
                type: 'text/javascript',
                src: 'https://presale.jhtsoft.com/SCPPrint.js'
              }
            }
          );
        },
      },// 顺丰外链组件
      PageLoading: () => import("@/components/common/PageLoading.vue"), //页面加载动画
    },
    watch: {
      senderShow(val) {
        this.currentDayIndex = 0;//选中的天索引
        this.currentTimeIndex = 0;//选中的时间段索引
        this.selectedtime = '';
        this.pickupStartTime = '';
        this.pickupEndTime = '';
        if (this.printType == 90 && val) {
          if (this.printconfig.openPickupTime == 1) {
            api.GET_PICKUPINTIMELIST().then(res => {
              if (res.data.status == "200") {
                this.canselDayList = res.data.data
                this.activeDayItem = this.canselDayList[0];
              }
            })
          }
        }
      },
      //按订单内容排序
      orderContProp() {
        if (this.orderContProp) {
          this.contentsort = 1;
          this.getPrintList();
        } else {
          this.contentsort = 0;
          this.getPrintList();
        }
      },
    },
    methods: {
      // 查询产品类型
      getExpressTypeList() {
        let params = {
          expcode: 'shunfeng',
        }
        api.GET_EXPRESSTYPELIST(params).then((res) => {
          if (res.data.status == "200") {
            this.sfexpresstypeList = [];
            this.allSfexpresstypeList = res.data.data;
            this.allSfexpresstypeList.forEach(item => {
              if (item.status == 1) {
                this.sfexpresstypeList.push(item);
              }
            })
          }
        })
      },
      //全选操作
      allCheckedChange() {
        if (this.multipleSelection.length > 0) {
          this.multipleSelection = []
        } else {
          this.printListData.forEach(res => {
            if (res.merger == 1 || this.setPackageNum) {
              this.multipleSelection.push(res)
            }
          })
          this.allSelect = true
        }
      },
      //热敏下单
      subOrder(val) {
        if (val == 3) {
          this.screenstate = 3
        } else {
          this.screenstate = ''
        }
        //校验
        if (this.printListData.length == 0) {
          MessageBox.alert('暂无可操作的快递！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        let canSubNum = 0
        let anSubNum = 0
        this.printListData.forEach(item => {
          if (!item.expno) {
            canSubNum++
          }
          if (val == 3 && item.screenstate == 3) {
            anSubNum++
          }
        })
        if (canSubNum == 0) {
          MessageBox.alert('暂无可下单的快递！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        if (val == 3 && anSubNum == 0) {
          MessageBox.alert('暂无可下单的快递！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        if (this.validateStartEnd() == false) {
          //验证不通过
          return false
        }

        if (this.printType == '110' && (this.printFormInline.expmodeofcn === '' || this.printFormInline.expmodeofcn == null)) {
          MessageBox.alert('请选择快递类型！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }

        if (this.printType == '110' && !this.printFormInline.sendAddr) {
          MessageBox.alert('请选择寄件地址！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        this.senderShow = true
      },

      validateStartEnd() {
        let reg = /^[0-9]+$/
        let total = this.printListData.length
        if (total == 0) {
          MessageBox.alert('暂无可下单的快递！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        let startNo = this.printFormInline.startSerial.toString()
        let endNo = this.printFormInline.endSerial.toString()
        if (startNo.replace(/\s/g, "") == "") {
          MessageBox.alert('请填写打印开始序号！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        } else if (!reg.test(startNo)) {
          MessageBox.alert('打印开始序号只能填写整数！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        } else if (parseInt(startNo) <= 0) {
          MessageBox.alert('打印开始序号只能大于0！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        } else if (parseInt(startNo) > parseInt(total)) {
          MessageBox.alert('打印开始序号不能大于快递总数！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        if (endNo.replace(/\s/g, "") == "") {
          MessageBox.alert('请填写打印结束序号！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        } else if (!reg.test(endNo)) {
          MessageBox.alert('打印结束序号只能填写整数！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        } else if (parseInt(startNo) > parseInt(endNo)) {
          MessageBox.alert('打印结束序号不能小于打印开始序号！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        } else if (parseInt(endNo) > parseInt(total)) {
          MessageBox.alert('打印结束序号不能大于快递总数！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        return true
      },

      // 配送方下拉选择值
      senderReceive(value) {
        this.sender = value
      },
      //关闭菜鸟提示框
      closeCNBox() {
        this.tipCNMsg = false
      },
      // 表格全选
      toggleSelect(rows) {
        if (rows) {
          rows.forEach(row => {
            if (row.merger == 1) {
              this.$refs.expressTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      //表格多选选中行复制
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      //按电话排序
      phoneTableSort() {
        this.orderbytel = 1
        this.getPrintList()
      },
      //查看排序方式
      changeTableSort(col) {
        //console.log(col)
      },
      //合并快递
      CombinedExpress(val) {
        if (val) {
          if (this.multipleSelection.length > 1) {
            MessageBox.confirm('你确定执行【合并快递】操作吗?', '信息确认', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              //合并勾选快递
              this.mergeExpress(0)
            }).catch(() => { })
          } else {
            MessageBox.alert('请选择你要合并的至少两个快递！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {
            }).catch(() => { })
          }
        } else {
          //全选
          this.multipleSelection = []
          this.printListData.forEach(res => {
            if (res.merger == 1) {
              this.multipleSelection.push(res)
            }
          })
          MessageBox.confirm('你确定执行【合并快递】操作吗?', '信息确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.mergeExpress(1)
          }).catch(() => {
            this.multipleSelection = []
          })
        }
      },
      //单号采集
      orderCollection() {
        this.$router.push({
          name: '单号采集列表',
          params: {
            nonOddCollection: false, //是否展示快递方式
          }
        })
      },
      //下单选择寄件方
      closeSenderBox(val) {
        if (val == 1) {
          if (this.sender) {
            this.postOrder()
          } else {
            MessageBox.alert('您还没有选择寄件方信息！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => { }).catch(() => { })
            return false
          }
        } else {
          this.senderShow = false;
          this.subLoading = false;
        }
      },
      //下单选择上门取件时间-天
      changeSelDay(item, index) {
        this.activeDayItem = item;
        this.currentDayIndex = index;
        this.currentTimeIndex = -1;
      },
      //下单选择上门取件时间-时间段
      changeSelTime(item, index) {
        this.currentTimeIndex = index;
        this.calendarpanel = false;
        this.selectedtime = this.activeDayItem.date + ' ' + item.pickupStartTime + '-' + item.pickupEndTime;
        this.pickupStartTime = this.activeDayItem.date + ' ' + item.pickupStartTime + ':00';
        this.pickupEndTime = this.activeDayItem.date + ' ' + item.pickupEndTime + ':00';
      },
      //提交热敏下单
      postOrder() {
        this.subLoading = true;
        let params = {
          startNo: this.printFormInline.startSerial,
          endNo: this.printFormInline.endSerial,
          handletype: this.printType,
          sendercode: this.sender,
          addrId: this.printFormInline.sendAddr,
          mark: this.printFormInline.expmodeofcn,
          attrValue: this.printType == '110' ? this.getAttrValue() : '',
          store: this.store,
          entity: this.entity,
          screenstate: this.screenstate,
        }
        if (this.printType == '90') {
          params.jdgoodstype = this.jdgoodstype;
          params.promisetimetype = this.promisetimetype;
        }
        if (this.printType == '1') {
          params.sfexpresstype = this.sfexpresstype;
        }
        if (this.printType == '90' && this.printconfig.openPickupTime == 1) {
          if (!this.pickupStartTime && !this.pickupEndTime) {
            MessageBox.alert('请选择上门取件时间！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => { }).catch(() => { })
            this.subLoading = false;
            return false
          } else {
            Vue.set(params, 'pickupStartTime', this.pickupStartTime);
            Vue.set(params, 'pickupEndTime', this.pickupEndTime);
          }
        }
        api.SUBORDER(params).then(res => {
          if (res.data.status == '200') {
            this.senderShow = false;
            MessageBox.alert(res.data.message, '系统提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              type: 'warning',
            }).then(() => { }).catch(() => { })
            this.getPrintList()
          } else {
            MessageBox.alert(res.data.message, '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => { }).catch(() => { })
          }
          this.subLoading = false;
        }).catch(res => {
          this.subLoading = false;
        })
      },

      //打开批量设置包裹梳弹窗
      setPknum() {
        this.setStatus = true
        this.setPackageNum = true
      },

      confirmCancel(val) {
        if (val) {
          if (this.multipleSelection.length == 0) {
            MessageBox.alert('请先勾选需要设置包裹数的快递！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => { }).catch(() => { })
          } else {
            this.setPknumShow = true
          }
        } else {
          this.setStatus = false
          this.setPackageNum = false
        }
      },

      //设置原有的包裹数量
      setOldPknum(val) {
        this.oldPknum = val
      },

      //更新快递包裹数量
      changePknum(exp) {
        if (exp.packagenum < 1) {
          MessageBox.alert('请输入正确的包裹数！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          exp.packagenum = 1
        } else {
          if (this.oldPknum != exp.packagenum) {
            this.expcodeArr = []
            this.expcodeArr.push(exp.expcode)
            api.UPDATEPACKAGENUM({ packagenum: exp.packagenum, expcode: this.expcodeArr }).then(res => {
              if (res.data.status == '200') {
                let params = {
                  expgenbatchnoArr: this.expgenbatchnoArr,
                  orderno: this.printFormInline.orderno,
                  bprint: this.bprint,
                  orderbytel: this.orderbytel,
                }
                api.FINDBATCHPRINT(params)
              } else {
                MessageBox.alert(res.data.message, '系统提示', {
                  confirmButtonText: '确定',
                  type: 'warning',
                }).then(() => { }).catch(() => { })
              }
            })
          }
        }
      },

      //关闭完善快递是确定还是取消
      clsBtnVal(val) {
        this.improveEprBtnVal = val
      },
      //关闭完善快递弹窗
      closeImproveExpress(val) {
        this.improveShow = false //完善快递弹窗
        if (Number(this.improveEprBtnVal)) {
          let rst = JSON.parse(val)
          this.expmoney = rst.expressAmount
          this.issend = rst.notice ? 1 : 0
          this.sendMsgDate = rst.messageDate ? this.dateTime(rst.messageDate, 1) : ''
          if (this.printType == '110') {//菜鸟热敏
            this.openPrintersFlag = true
            this.doConnect()
            let request = this.getRequestObject(this.cnParams.cmd_getPrinters);
            this.webSocket.send(JSON.stringify(request));
          } else if (this.printType == '79') {//韵达热敏
            //获取初始化信息

            //请求打印控件

            //完成打印

          } else if (this.printType == '1' && this.printconfig.cloudprint === 1) {
            this.initSFCloud()
          } else if (this.printType == '90' && this.printconfig.cloudprint === 1) {
            this.jdconnect()
          } else {
            this.initRmPrint()
          }
        }
      },

      getRequestObject(cmd) {
        let request = new Object();
        request.requestID = this.getUUID(8, 16);
        request.version = this.verson;
        request.cmd = cmd;
        return request;
      },

      getUUID(len, radix) {
        let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        let uuid = [], i;
        radix = radix || chars.length;
        if (len) {
          for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
        } else {
          let r;
          uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
          uuid[14] = '4';
          for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
              r = 0 | Math.random() * 16;
              uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
          }
        }
        return uuid.join('');
      },

      initRmPrint() {
        let total = this.printListData.length
        if (total == 0) {
          MessageBox.alert('暂无可下单的快递！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        let startNo = this.printFormInline.startSerial
        let endNo = this.printFormInline.endSerial
        let cmpyname
        let sendermob
        let sendertel
        let senderaddr
        let senderaddr1
        let senderaddr2

        // 顺丰配置参数 start ------------------------
        let sfcustid = this.printconfig.sfcustid
        let origincode = this.printconfig.origincode
        let courier = this.printconfig.courier
        let sendername = this.printconfig.sendername
        let guavalueamount = this.printconfig.guavalueamount
        let sfpaymethod = this.printconfig.sfpaymethod
        if (sfpaymethod == '' || sfpaymethod == "1") {
          if (sfpaymethod == "1" && sfcustid != null && sfcustid.length > 0) {
            sfpaymethod = "寄付月结"
          } else {
            sfpaymethod = "寄方付"
          }
        } else if (sfpaymethod == "2") {
          sfpaymethod = "收方付"
        } else if (sfpaymethod == "3") {
          sfpaymethod = "第三方付"
        }
        let sfexpresstype = this.printconfig.sfexpresstype;
        this.allSfexpresstypeList.some(item => {
          if (sfexpresstype === item.productcode) {
            sfexpresstype = item.description;
            return true;
          }
        })
        // if(sfexpresstype === "1"){
        //   sfexpresstype = "顺丰标快"
        // } else if(sfexpresstype === "2") {
        //   sfexpresstype = "顺丰标快（陆运）"
        // } else if(sfexpresstype === "5") {
        //   sfexpresstype = "顺丰次晨"
        // } else if(sfexpresstype === "6") {
        //   sfexpresstype = "顺丰即日"
        // } else if(sfexpresstype === "9") {
        //   sfexpresstype = "国际小包平邮"
        // } else if(sfexpresstype === "10") {
        //   sfexpresstype = "国际小包挂号"
        // } else if(sfexpresstype === "23") {
        //   sfexpresstype = "顺丰国际特惠(文件)"
        // } else if(sfexpresstype === "29") {
        //   sfexpresstype = "国际电商专递-标准"
        // } else if(sfexpresstype === "31") {
        //   sfexpresstype = "便利封/袋(标快)"
        // } else if(sfexpresstype === "33") {
        //   sfexpresstype = "岛内件(80CM)"
        // } else if(sfexpresstype === "53") {
        //   sfexpresstype = "高铁站配"
        // } else if(sfexpresstype === "111") {
        //   sfexpresstype = "顺丰特惠D"
        // } else if(sfexpresstype === "112") {
        //   sfexpresstype = "顺丰空配"
        // } else if(sfexpresstype === "153") {
        //   sfexpresstype = "整车直达"
        // } else if(sfexpresstype === "154") {
        //   sfexpresstype = "重货包裹"
        // } else if(sfexpresstype === "155") {
        //   sfexpresstype = "标准零担"
        // } else if(sfexpresstype === "174") {
        //   sfexpresstype = "重货包裹B"
        // } else if(sfexpresstype === "195") {
        //   sfexpresstype = "医药安心递-陆"
        // } else if(sfexpresstype === "199") {
        //   sfexpresstype = "极速包裹"
        // } else if(sfexpresstype === "201") {
        //   sfexpresstype = "冷运标快"
        // } else if(sfexpresstype === "202") {
        //   sfexpresstype = "顺丰微小件"
        // } else if(sfexpresstype === "208") {
        //   sfexpresstype = "特惠专配"
        // } else if(sfexpresstype === "209") {
        //   sfexpresstype = "高铁专送"
        // } else if(sfexpresstype === "215") {
        //   sfexpresstype = "大票直送"
        // } else if(sfexpresstype === "221") {
        //   sfexpresstype = "香港冷运到家(≤60厘米)"
        // } else if(sfexpresstype === "229") {
        //   sfexpresstype = "精温专递"
        // } else if(sfexpresstype === "231") {
        //   sfexpresstype = "陆运包裹"
        // } else if(sfexpresstype === "233") {
        //   sfexpresstype = "精温专递(样本陆)"
        // } else if(sfexpresstype === "234") {
        //   sfexpresstype = "商务标快"
        // } else if(sfexpresstype === "235") {
        //   sfexpresstype = "极效前置"
        // } else if(sfexpresstype === "238") {
        //   sfexpresstype = "纯重特配"
        // } else if(sfexpresstype === "242") {
        //   sfexpresstype = "丰网速运"
        // } else if(sfexpresstype === "243") {
        //   sfexpresstype = "同城即日"
        // } else if(sfexpresstype === "247") {
        //   sfexpresstype = "电商标快"
        // }

        let sfprintpagetype = this.printconfig.sfprintpagetype
        if (sfprintpagetype == "") {
          sfprintpagetype = 0
        }
        let bprintaccount = this.printconfig.bprintaccount
        let sfzmjnum = 1
        let printmemo_SF = this.printconfig.printmemo
        // 顺丰配置参数 end ------------------------

        // 京东配置参数 start ------------------------
        let bguavalue = this.printconfig.bguavalue
        let jdgoodstype = this.printconfig.jdgoodstype
        let promisetimetype = this.printconfig.promisetimetype
        let customercode = this.printconfig.customercode
        //是否调换备注和商品内容位置
        let changeposition = this.printconfig.changeposition
        //运输方式
        let transtype = this.printconfig.transtype
        //打印面单
        let jdprinttype = this.printconfig.jdprinttype
        //京东新面单是否展示T
        let showt = false
        if (jdgoodstype === "1") {
          jdgoodstype = "普通"
        } else if (jdgoodstype === "4") {
          jdgoodstype = "特配"
        } else if (jdgoodstype === "3") {
          jdgoodstype = "填仓"
        } else if (jdgoodstype === "7") {
          jdgoodstype = "冷藏"
        } else if (jdgoodstype === "6") {
          jdgoodstype = "控温"
        } else if (jdgoodstype === "8") {
          jdgoodstype = "冷冻"
        } else if (jdgoodstype === "9") {
          jdgoodstype = "深冷"
        } else if (jdgoodstype === "5") {
          jdgoodstype = "鲜活"
        }

        if (promisetimetype === "1") {
          promisetimetype = "特惠送"
        } else if (promisetimetype === "2") {
          showt = true
          promisetimetype = "特快送"
        } else if (promisetimetype === "4") {
          promisetimetype = "城际即日"
        } else if (promisetimetype === "7") {
          promisetimetype = "特惠送"
        } else if (promisetimetype === "8") {
          promisetimetype = "生鲜专送"
        } else if (promisetimetype === "14") {
          promisetimetype = "极速达"
        } else if (promisetimetype === "15") {
          promisetimetype = "同城速配"
        } else if (promisetimetype === "16") {
          showt = true
          promisetimetype = "生鲜特快"
        } else if (promisetimetype === "17") {
          promisetimetype = "生鲜特惠"
        } else if (promisetimetype === "20") {
          promisetimetype = "函速达"
        } else if (promisetimetype === "21") {
          promisetimetype = "特惠包裹"
        }
        let printmemo_JD = this.printconfig.printmemo
        // 京东配置参数 end ------------------------

        // 圆通配置参数 start ------------------------
        let ytscancode = this.printconfig.ytscancode//商家营销二维码
        let ytagproduct = this.printconfig.ytagproduct//时效产品
        let ytaddserv = this.printconfig.ytaddserv//增值服务
        let ytagencypayfee = this.printconfig.ytagencypayfee//代收货款
        let ytinsuranceamount = this.printconfig.ytinsuranceamount//保价值
        let matchcode//三段码
        let paytype//支付方式
        let flag = false;
        // 圆通配置参数 end ------------------------

        let count = 0

        // 跨越配置参数 start ------------------------
        let modelType = this.printconfig.kymodeltype//0:最初模板 1：果鲜模板
        let printType = this.printconfig.kyprinttype//0:二联单 1:三联单
        let kypaytype = this.printconfig.kypaytype//支付方式
        let kyexptype = this.printconfig.kyexptype//快递方式
        let kyinsuranceamount = this.printconfig.kyinsuranceamount//保价声明值
        let kyagencypayamount = this.printconfig.kyagencypayamount//代收金额
        let kyagencypayfee = this.printconfig.kyagencypayfee//代收手续费
        let kycustid = this.printconfig.kycustid//月结账号
        let platformmemo//平台备注
        let printmemo_1st = this.printconfig.printmemo
        // 跨越配置参数 start ------------------------

        // 承诺达配置参数 start ------------------------
        //let matchcode//三段码
        let distributeCenterCode//末端集散中心代码
        let totalfee = 0//商品总额
        let printmemo_cnd = this.printconfig.printmemo
        // 承诺达配置参数 end ------------------------


        let idx
        let expno
        let screenstate
        let ordtype
        let destcode
        let destRouteLabel
        let childno
        let sellermemo
        //备注
        let expmemo
        let reg = new RegExp("@", "g")//g,表示全部替换
        let platformname
        let cmpname
        let receivername
        let receivertel
        let receiveraddr
        let receiveraddr1
        let receiveraddr2
        let othtel
        let buyermemo
        let expcontent
        let backno
        let orderid
        let num = 0
        let arrnum = 0
        let childnoArr
        let arr = new Array()
        let taskMap = {}

        let taskId = 1

        //由于当前方法提前返回结果 不知道当前是否执行打印操作  设置费用和消息发送时间的逻辑嵌套在里面
        if (LODOP.CVERSION) {
          //选择打印机列表的回调函数
          CLODOP.On_Return = (TaskID, Value) => {
            if (Value >= 0) {
              //设定当前打印机为选择打印机  value：为选择打印机的序号
              LODOP.SET_PRINTER_INDEXA(Value)
              this.loadingCover = true; //打印加载中，勿动
              this.printListData.forEach((item, index) => {
                idx = index + 1
                expno = item.expno
                screenstate = item.screenstate
                if (idx >= startNo && idx <= endNo && expno != null && expno != "" && screenstate == 1) {
                  cmpyname = item.cmpyname
                  sendername = item.sendername
                  sendertel = item.sendertel
                  sendermob = item.sendermob ? item.sendermob : item.sendertel ? item.sendertel : ''
                  senderaddr = item.sprovince + item.scity + item.sdistrict + item.saddrdet
                  senderaddr1 = item.sprovince + "，" + item.scity + "，" + item.sdistrict
                  senderaddr2 = item.saddrdet
                  cmpname = item.cmpname
                  receivername = item.receivername
                  receivertel = item.receivertel
                  expmemo = item.expmemo
                  othtel = item.othtel

                  ordtype = item.content.ordtype
                  origincode = item.content.origincode
                  destcode = item.content.destcode
                  destRouteLabel = item.content.destRouteLabel
                  childno = item.content.childno
                  platformname = item.channelname
                  if (platformname != null && platformname != "" && platformname != "企业总部" && platformname != "企业商城") {
                    platformname = "[" + item.channelname.replace(reg, " ") + "]"
                    sellermemo = item.sellermemo
                  } else {
                    sellermemo = item.sellermemo
                  }
                  receiveraddr = item.fulladdr
                  receiveraddr1 = item.province + "，" + item.city + "，" + item.district
                  receiveraddr2 = item.addrdet
                  buyermemo = item.buyermemo
                  expcontent = item.expcontent
                  backno = item.content.backno
                  orderid = item.porderno
                  if (orderid == "0" || orderid == 0) {
                    orderid = item.orderno
                  }
                  if (othtel == null || othtel == "" || othtel == receivertel) {
                    othtel = ""
                  } else {
                    receivertel = receivertel + "  " + othtel
                  }
                  if (ordtype == 1) {
                    childnoArr = childno.split(",")
                    sfzmjnum = childnoArr.length + 1
                  }

                  matchcode = item.content.matchcode//三段码
                  destcode = item.content.destcode
                  paytype = "寄付"
                  if (expcontent.indexOf(";") > 0) {
                    let goods = expcontent.split(";");
                    for (let i = 0; i < goods.length; i++) {
                      let goodNum = goods[i].substring(0, goods[i].indexOf("份"));
                      count = count + parseInt(goodNum);
                    }
                  } else {
                    let goodNum = expcontent.substring(0, expcontent.indexOf("份"));
                    count = parseInt(goodNum);
                  }
                  if (matchcode != null && matchcode != "" && matchcode.indexOf(" ") > 0) {
                    let codes = matchcode.split(" ");
                    if (codes.length > 1 && codes[codes.length - 1] != null && codes[codes.length - 1] != "") {
                      matchcode = codes[codes.length - 1];
                      flag = true;
                    }
                  }

                  platformmemo = item.channelname;
                  if (platformmemo != null && platformmemo != "") {
                    platformmemo = "[" + platformmemo + "]";
                  } else if (platformmemo != null && platformmemo != "" && platformmemo.indexOf("@") > 0) {
                    platformmemo = "";
                  }

                  totalfee = item.actpayamount
                  if (totalfee == null || totalfee == '') {
                    totalfee = item.price
                  }

                  num++
                  if (this.printType == '111') {
                    if (num % 5 == 1) {
                      LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
                      LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS", true);
                      LODOP.PRINT_INITA("0mm", "0mm", "100mm", "180mm", "圆通承诺达快递打印");
                      LODOP.SET_PRINT_PAGESIZE(0, 1000, 1800, "");
                    }
                    LODOP.NewPage();
                  }
                  if (this.printType == '1') {//顺丰打印
                    print.drawSfPrint(ordtype, sfzmjnum, 1, "", sfprintpagetype, expno,
                      receiveraddr1, receiveraddr2, receivername, receivertel, origincode, destcode, destRouteLabel,
                      sfexpresstype, sfpaymethod, sellermemo, expcontent, backno, courier, guavalueamount,
                      sfcustid, senderaddr1, senderaddr2, sendername, sendermob, orderid, 0, taskId++, idx, expmemo, item.content, cmpyname, bprintaccount, printmemo_SF)
                  } else if (this.printType == '90') {//京东打印
                    print.drawJdPrint(idx, expno, receivername, receivertel, othtel, item.content, item.fulladdr, expcontent, sellermemo,
                      jdgoodstype, bguavalue, guavalueamount, senderaddr, sendername, sendermob, orderid, customercode,
                      promisetimetype, changeposition, transtype, showt, jdprinttype, printmemo_JD)
                  } else if (this.printType == '2') {//圆通打印
                    print.drawYtPrint(ytscancode, cmpyname, sendername, sendermob, senderaddr, ytagproduct, ytaddserv, ytagencypayfee,
                      ytinsuranceamount, expno, matchcode, paytype, receivername, receivertel, receiveraddr, expcontent, count,
                      cmpname, orderid, flag, destcode);
                  } else if (this.printType == '97') {//安能打印
                    print.drawAnPrint(item.content.destAllocateName, item.content.targetsortcentername, item.content.targetsortcenterid,
                      receivername, receivertel, receiveraddr1, receiveraddr2, cmpyname, sendertel, senderaddr, expno, item.content.fourSegmentCode, expcontent);
                  } else if (this.printType == '100') {//跨越打印
                    if (modelType == 0 && printType == 0) {
                      print.drawKyPrint_2nd(cmpyname, sendername, sendermob, kypaytype, kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
                        kycustid, expno, destcode, receivername, receivertel, receiveraddr, sellermemo, platformmemo, expcontent, count, item.expmoney, cmpname, printmemo_1st);
                    } else if (modelType == 0 && printType == 1) {
                      print.drawKyPrint_1st(cmpyname, sendername, sendermob, kypaytype, kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
                        kycustid, expno, destcode, receivername, receivertel, receiveraddr, sellermemo, platformmemo, expcontent, count, item.expmoney, cmpname, printmemo_1st);
                    } else if (modelType == 1 && printType == 0) {
                      print.drawKyPrint_3rd(cmpyname, sendername, sendermob, kypaytype, kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
                        kycustid, expno, destcode, receivername, receivertel, receiveraddr, sellermemo, platformmemo, expcontent, count, item.expmoney, cmpname,
                        item.content.sitename, item.content.startflight, item.content.endflight, item.content.flightno, item.content.charterno, printmemo_1st);
                    } else if (modelType == 1 && printType == 1) {
                      print.drawKyPrint_4th(cmpyname, sendername, sendermob, kypaytype, kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
                        kycustid, expno, destcode, receivername, receivertel, receiveraddr, sellermemo, platformmemo, expcontent, count, item.expmoney, cmpname,
                        item.content.sitename, item.content.startflight, item.content.endflight, item.content.flightno, item.content.charterno, printmemo_1st);
                    } else if (modelType == 2 && printType == 0) {
                      print.drawKyPrint_5th(cmpyname, sendername, sendermob, kypaytype, kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
                        kycustid, expno, destcode, receivername, receivertel, receiveraddr, sellermemo, expcontent, count, item.expmoney, cmpname,
                        item.content.sitename, item.content.startflight, item.content.endflight, item.content.flightno, item.content.charterno);
                    } else if (modelType == 2 && printType == 1) {
                      print.drawKyPrint_6th(cmpyname, sendername, sendermob, kypaytype, kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
                        kycustid, expno, destcode, receivername, receivertel, receiveraddr, sellermemo, expcontent, count, item.expmoney, cmpname,
                        item.content.sitename, item.content.startflight, item.content.endflight, item.content.flightno, item.content.charterno);
                    }
                  } else if (this.printType == '111') {//承诺达打印
                    print.drawCndPrint(cmpyname, sendername, sendermob, senderaddr, this.printconfig.cndagproduct, this.printconfig.cndaddserv,
                      this.printconfig.cndagencypayfee, this.printconfig.cndinsuranceamount, expno, matchcode, paytype, receivername, receivertel,
                      receiveraddr, expcontent, count, cmpname, orderid, flag, destcode, item.content.destcode, totalfee, sellermemo, printmemo_cnd);
                  }
                  //---------------------------------------
                  //LODOP.PRINT_DESIGN()
                  //P_ID = LODOP.PRINTA()//直接打印
                  //return
                  debugger;
                  LODOP.On_Return_Remain = true
                  LODOP.On_Return = (TaskID, Value) => {
                    console.log("taskID:" + TaskID)
                    let taskStr = arr.join("")
                    if (arr[arr.length - 1] == TaskID && (Value == true || Value == "true")) {
                      Vue.delete(taskMap, TaskID)
                      if (Object.keys(taskMap).length > 0) {
                        let taskValues = ""
                        for (let key in taskMap) {
                          let e = taskMap[key]
                          taskValues = taskValues + e + ","
                        }
                        this.addExpprintBatch(startNo, endNo, this.repeatmemo, taskValues)
                      } else {
                        this.addExpprintBatch(startNo, endNo, this.repeatmemo, "")
                      }

                    }
                    else if (taskStr.indexOf(TaskID) >= 0 && (Value == true || Value == "true")) {
                      Vue.delete(taskMap, TaskID)
                    }
                  }

                  this.P_ID = LODOP.PRINT()//直接打印PRINT
                  //this.P_ID = LODOP.PRINT_DESIGN()
                  //arr.add(P_ID)
                  arr[arrnum] = this.P_ID + ""
                  arrnum++
                  Vue.set(taskMap, "" + this.P_ID, idx)
                  console.log("顺丰新面单打印任务统计：" + num + "&&&" + this.P_ID)
                  let childexpno
                  if (ordtype == 1) {
                    //子母单，打印子单
                    for (let k = 0; k < childnoArr.length; k++) {
                      childexpno = childnoArr[k]
                      if (childexpno != null && childexpno != "") {
                        print.drawSfPrint(ordtype, sfzmjnum, (2 + k), expno, sfprintpagetype, childexpno,
                          receiveraddr1, receiveraddr2, receivername, receivertel, origincode, destcode, destRouteLabel,
                          sfexpresstype, sfpaymethod, sellermemo, expcontent, backno, courier, guavalueamount,
                          sfcustid, senderaddr1, senderaddr2, sendername, sendermob, orderid, 0, taskId++, idx, expmemo, item.content, cmpyname, bprintaccount)

                        this.P_ID = LODOP.PRINT()//直接打印
                        arr[arrnum] = this.P_ID + ""
                        arrnum++
                        Vue.set(taskMap, "" + this.P_ID, idx)
                      }
                    }
                  }
                  if (backno != null && backno != "" && this.printType == '1') {
                    print.drawSfPrint(0, 1, 1, "", sfprintpagetype, backno,
                      senderaddr1, senderaddr2, sendername, sendermob, destcode, destRouteLabel, origincode,
                      "签单返还", "到付", "", expcontent, "", courier, "",
                      sfcustid, receiveraddr1, receiveraddr2, receivername, receivertel, orderid, 1, taskId++, idx, expmemo, item.content, cmpyname, bprintaccount)
                    this.P_ID = LODOP.PRINT()//直接打印
                    arr[arrnum] = this.P_ID + ""
                    arrnum++
                    Vue.set(taskMap, "" + this.P_ID, idx)
                  }
                }
              })
              this.loading = false
              if (num == 0) {
                MessageBox.alert('暂无筛单成功的快递，请下单后再打印！', '系统提示', {
                  confirmButtonText: '确定',
                  type: 'warning'
                }).then(() => { }).catch(() => { })
              }

            } else {
              this.loading = false
              MessageBox.alert('取消当前打印操作！', '系统提示', {
                confirmButtonText: '确定',
                type: 'warning'
              }).then(() => { }).catch(() => { })
            }
          }
          //选择打印列表信息
          LODOP.SELECT_PRINTER()
          //将打印份数隐藏
          // $("select").next("input").hide()
          // $("select").parent("div").children("div").eq(1).children("span").eq(1).hide()
          return
        }
      },

      doConnect() {
        if (this.webSocket) {
          return true
        }
        this.loading = true
        this.webSocket = new WebSocket('ws://127.0.0.1:13528')
        this.webSocket.onopen = (event) => {
          this.loading = false
          if (this.openPrintersFlag) {
            this.subPrint()
          }
        }
        this.webSocket.onclose = (event) => {
          this.webSocket = null
        }
        this.webSocket.onerror = (event) => {
          this.loading = false
          this.tipCNMsg = true // 菜鸟控件提示
        }
        this.webSocket.onmessage = (event) => {
          const data = JSON.parse(event.data);
          if (this.cnParams.cmd_getPrinters == data.cmd) {
            this.openPrintersFlag = false
            let defaultPrinter = data.defaultPrinter
            this.selectedPrint = defaultPrinter
            let allPrinters = data.printers
            let length = allPrinters.length
            if (length <= 0) {
              MessageBox.alert("没有可使用的打印机！", '系统提示', {
                confirmButtonText: '确定',
                type: 'warning',
              }).then(() => { }).catch(() => { })
              return false
            }
            let item
            this.printList = []
            for (let i = 0; i < length; i++) {
              item = allPrinters[i].name;
              this.printList.push({ label: item, value: item })
            }
            this.setPrintShow = true
          } else if (this.cnParams.cmd_setPrinterConfig == data.cmd) {
            this.doPrint()
          } else if (this.cnParams.cmd_print == data.cmd) {
            if (this.cnParams.isdialog) {
              //弹框弹出了
              return false
            }
            this.cnParams.isdialog = true

            //完成打印
            this.finishParam = {
              startNo: this.printFormInline.startSerial,//起始序号
              endNo: this.printFormInline.endSerial,//结束序号
              printType: this.printType,//快递处理方式
              expmoney: this.expmoney,//快递费用
              issend: this.issend,//是否发送短信通知
              sendMsgDate: this.sendMsgDate,//短信通知日期
              mark: this.printFormInline.expmodeofcn,
            }
            this.finishedPrint()

            //打印成功
          } else if ("notifyPrintResult" == data.cmd) {
            //---
          }
        }
      },

      doPrint() {
        this.doConnect()
        this.loading = true
        let params = {
          startNo: this.printFormInline.startSerial,
          endNo: this.printFormInline.endSerial,
          mark: this.printFormInline.expmodeofcn,
        }
        api.GET_CNDOCUMENT(params).then(res => {
          if (res.data.status == '200') {
            let waybillArray = res.data.data
            let cn_task_num = 10
            this.cnParams.isdialog = false
            //未配置或配置的值大于要打印文档对象数量
            if (cn_task_num == null || cn_task_num == '' || parseInt(cn_task_num) >= waybillArray.length) {
              let request = this.getRequestObject(this.cnParams.cmd_print)
              request.task = new Object()
              request.task.taskID = this.getUUID(8, 10)
              request.task.preview = false
              request.task.printer = this.cnParams.defaultPrinter
              request.task.notifyMode = "allInOne"

              waybillArray.forEach((item, index) => {
                let tmp_waybillArray = item.contents[1].data.memo
                console.log('打印数据waybillArray1', item, tmp_waybillArray)
                let meno = '' // 最终打印备注
                let tmp_meno = ''
                let tmp_length = (tmp_waybillArray ? tmp_waybillArray.length : 0) + (this.printconfig.printmemo ? this.printconfig.printmemo.length : 0)
                if (tmp_length > 40) {
                  tmp_meno = tmp_waybillArray.substring(0, (40 - (this.printconfig.printmemo ? this.printconfig.printmemo.length : 0) - 4)) + '...'
                } else {
                  tmp_meno = tmp_waybillArray ? tmp_waybillArray : ''
                }
                // printmemo 统一打印备注，传入
                meno = tmp_meno + ' ' + (this.printconfig.printmemo ? this.printconfig.printmemo : '')
                item.contents[1].data.memo = meno
              })
              console.log('打印数据waybillArray1-修改后的', waybillArray)

              request.task.documents = waybillArray
              this.webSocket.send(JSON.stringify(request))
            } else {
              waybillArray.forEach((item, index) => {
                let tmp_waybillArray = item.contents[1].data.memo
                console.log('打印数据waybillArray-超过10个', item, tmp_waybillArray)
                let meno = '' // 最终打印备注
                let tmp_meno = ''
                let tmp_length = (tmp_waybillArray ? tmp_waybillArray.length : 0) + (this.printconfig.printmemo ? this.printconfig.printmemo.length : 0)
                if (tmp_length > 40) {
                  tmp_meno = tmp_waybillArray.substring(0, (40 - (this.printconfig.printmemo ? this.printconfig.printmemo.length : 0) - 4)) + '...'
                } else {
                  tmp_meno = tmp_waybillArray ? tmp_waybillArray : ''
                }
                // printmemo 统一打印备注，传入
                meno = tmp_meno + ' ' + (this.printconfig.printmemo ? this.printconfig.printmemo : '')
                item.contents[1].data.memo = meno
              })

              console.log('打印数据waybillArray1-修改后的数组', waybillArray)

              for (let i = 0; i < waybillArray.length; i += parseInt(cn_task_num)) {
                let waybillArr = waybillArray.slice(i, i + parseInt(cn_task_num))
                let request = this.getRequestObject(this.cnParams.cmd_print);
                request.task = new Object();
                request.task.taskID = this.getUUID(8, 10);
                request.task.preview = false;
                request.task.printer = this.cnParams.defaultPrinter;
                request.task.notifyMode = "allInOne";
                request.task.documents = waybillArr;
                this.webSocket.send(JSON.stringify(request));
              }
            }
          } else {
            MessageBox.alert(res.data.message, '系统提示', {
              confirmButtonText: '确定',
              type: 'warning',
            }).then(() => { }).catch(() => { })
          }
          this.loading = false
        })
      },

      //添加快递打印批次
      addExpprintBatch(startNo, endNo, repeatmemo, taskValues) {
        this.loading = true
        let params = {
          startNo: startNo,
          endNo: endNo,
          printType: this.printType,
          taskValues: taskValues,
          expbatchno: this.expgenbatchnoArr.length == 1 ? this.expgenbatchnoArr[0] : '',
          repeatmemo: this.repeatmemo,
        }
        api.ADDEXPPRINTBATCH(params).then(res => {
          if (res.data.status == '200') {
            //更改快递状态
            //完成打印
            this.finishParam = {
              startNo: this.printFormInline.startSerial,//起始序号
              endNo: this.printFormInline.endSerial,//结束序号
              printType: this.printType,//快递处理方式
              expmoney: this.expmoney,//快递费用
              issend: this.issend,//是否发送短信通知
              sendMsgDate: this.sendMsgDate,//短信通知日期
              taskValues: taskValues,
            }
            this.finishedPrint(res.data.data ? res.data.data : '')
          } else {
            MessageBox.alert(res.data.message, '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => { }).catch(() => { })
          }
          this.loading = false
        })
      },

      //打印维护操作
      printMaintenance() {
        if (this.printListData.length == 0) {
          MessageBox.alert('暂无可打印的订单', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
        }
        if (this.printFormInline.expressWay == '') {
          MessageBox.alert('请先选择面单类型再进行操作！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
        } else {
          //调取打印控件
          const LODOP = getLodop()
          if (LODOP) {
            if (this.initPrint(0)) {
              LODOP.PRINT_SETUP()/**打印维护，对整页的打印布局和打印风格进行界面维护，它与打印设计的区别是不具有打印项增删功能**/
            }
          }
        }
      },

      //面单维护初始化
      initPrint(flg) {
        let flag = true//循环标识

        /**初始化所选的打印模板**/
        this.expressWayList.forEach(item => {
          if (item.value == this.printFormInline.expressWay) {
            this.exptype = item.expmodeid
            this.printInfo.element = JSON.parse(item.element)
            this.printInfo.toffset = item.toffset
            this.printInfo.loffset = item.loffset
            this.printInfo.wpagesize = item.wpagesize
            this.printInfo.hpagesize = item.hpagesize
            this.printInfo.fontsize = item.fontsize
            this.printInfo.fontfamily = item.fontfamily
            this.printInfo.wordspace = item.wordspace
            this.printInfo.lineheight = item.lineheight
            this.printInfo.bgurl = "<img border='0' src='" + item.bgurl + "'/>"

            LODOP.PRINT_INITA(item.toffset + "mm", item.loffset + "mm", item.wpagesize + "mm", item.hpagesize + "mm", "快递打印任务" + item.label)/**打印初始化，参数：整页上边距，整页左边距，可视编辑区域的宽度，可视编辑区域的高度，打印任务名；**/
            LODOP.SET_PRINT_PAGESIZE(0, item.wpagesize + "mm", item.hpagesize + "mm", "")/**设定纸张大小，参数：打印方向及纸张类型，设定自定义纸张宽度，固定纸张时设定纸张高，所选纸张类型名**/
            LODOP.ADD_PRINT_SETUP_BKIMG(this.printInfo.bgurl)/**指定背景图**/
            LODOP.SET_SHOW_MODE("BKIMG_WIDTH", item.wpagesize + "mm")/**设置显示模式，设置背景图宽度**/
            LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", item.hpagesize + "mm")/**设置显示模式，设置背景图高度**/

            flag = false
          }
        })
        if (flag) {
          alert("没有可使用的快递模版，请联系管理员进行设置！")
          return false
        }
        if (this.printInfo.fontsize == null || this.printInfo.fontsize == "") {
          this.printInfo.fontsize = 12
        }
        if (this.printInfo.fontfamily == null || this.printInfo.fontfamily == "") {
          this.printInfo.fontfamily = "宋体"
        }
        if (this.printInfo.wordspace == null || this.printInfo.wordspace == "") {
          this.printInfo.wordspace = 0
        }
        if (this.printInfo.lineheight == null || this.printInfo.lineheight == "") {
          this.printInfo.lineheight = 0
        }
        LODOP.SET_SHOW_MODE("NP_NO_RESULT", true)/**设置NP插件无返回，这可避免chrome（谷歌）等np插件浏览器对弹窗超时误报崩溃**/
        if (flg == 0) {//0：打印维护     1:面单打印
          //LODOP.ADD_PRINT_TEXTA("打印时间",1,1,100,30,printDate)//打印时间
          for (let key in this.printInfo.element) {
            if (this.printInfo.element[key].isprint == 1) {
              LODOP.ADD_PRINT_TEXTA(this.printInfo.element[key].fieldname, this.printInfo.element[key].y, this.printInfo.element[key].x, this.printInfo.element[key].w, this.printInfo.element[key].h, key)/**增加纯文本打印项**/
              /**设置打印风格**/
              LODOP.SET_PRINT_STYLEA("All", "FontSize", this.printInfo.fontsize)
              LODOP.SET_PRINT_STYLEA("All", "FontName", this.printInfo.fontfamily)
              LODOP.SET_PRINT_STYLEA("All", "ItemLetterSpacing", this.printInfo.wordspace + "mm")//字间距
              LODOP.SET_PRINT_STYLEA("All", "ItemLineSpacing", this.printInfo.lineheight + "mm")//行间距
            }
          }
        }
        LODOP.SET_SHOW_MODE("HIDE_PAPER_BOARD", true)//隐藏走纸板
        LODOP.SET_SHOW_MODE("BKIMG_IN_PREVIEW", 1)//打印预览时是否包含背景图
        return true
      },

      //面单打印
      sheetPrint() {
        if (this.printListData.length == 0) {
          MessageBox.alert('暂无可打印的订单', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
        }
        if (this.printFormInline.expressWay == '') {
          MessageBox.alert('请先选择面单类型再进行操作！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
        } else {
          //调取打印机
          const LODOP = getLodop()
          if (LODOP) {
            this.printUp()
          }

          //this.domSheetShow = true
        }
      },

      Exp() {
        this.id = ""
        this.sellermemo = ""
        this.cmpname = ""
        this.receivername = ""
        this.receivertel = ""
        this.othtel = ""
        this.fulladdr = ""
        this.buyermemo = ""
        this.expcontent = ""
      },

      //打印操作
      printUp() {
        this.P_ID = null
        if (this.senderInfo == null || this.senderInfo == "") {
          MessageBox.alert('打印失败，您还没有设置默认寄件方信息，请联系管理员进行设置！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }

        this.loading = true

        let startNo = this.printFormInline.startSerial
        let endNo = this.printFormInline.endSerial
        let prenum = 0
        let idx
        let value
        let expArr = []
        let expinfoname = this.printFormInline.expressWay

        //遍历快递
        this.printListData.forEach((item, index) => {
          idx = index + 1
          if (idx >= startNo && idx <= endNo) {
            let citem = new this.Exp()
            citem.sellermemo = item.sellermemo
            citem.cmpname = item.cmpname
            citem.receivername = item.receivername
            citem.receivertel = item.receivertel
            citem.othtel = item.othtel
            if (citem.othtel == null || citem.othtel == "" || citem.othtel == citem.receivertel) {
              citem.othtel = ""
            }
            citem.fulladdr = item.fulladdr
            citem.buyermemo = item.buyermemo
            citem.expcontent = item.expcontent
            citem.id = item.expid
            expArr.push(citem)
          }
        })

        let len = expArr.length
        if (len == 0) {
          MessageBox.alert('暂无可操作的快递！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          this.loading = false
          return false
        }
        let flg = this.initPrint(1)

        if (flg == false) {
          this.loading = false
          return false
        }

        for (let i = 0; i < len; i++) {
          let item = expArr[i]
          LODOP.NewPage()/**强制分页。执行该函数之后所增加的内容会在前面内容的首页之后新建一页输出，前面无内容时，仍然从第一页开始**/
          //LODOP.ADD_PRINT_TEXTA("打印时间",1,1,100,30,printDate)//打印时间
          for (let key in this.printInfo.element) {
            if (this.printInfo.element[key].isprint == 1) {
              if (key == "寄件方公司名称") value = this.senderInfo.cmpyname
              if (key == "寄件人姓名") value = this.senderInfo.sendername
              if (key == "寄件人手机") value = this.senderInfo.sendermob
              if (key == "寄件人电话") value = this.senderInfo.sendertel
              if (key == "寄件方地址") value = this.senderInfo.province + this.senderInfo.city + this.senderInfo.district + this.senderInfo.addrdet

              if (key == "取件人") value = this.senderInfo.courier
              if (key == "寄件人") value = this.senderInfo.sendername

              if (key == "卖家备注") value = item.sellermemo
              if (key == "收件方公司名称") value = item.cmpname
              if (key == "收件人姓名") value = item.receivername
              if (key == "收件人联系方式") value = item.receivertel
              if (key == "收件人备用联系方式") value = item.othtel
              if (key == "收件人地址") value = item.fulladdr
              if (key == "买家备注") value = item.buyermemo
              if (key == "快递内容") value = item.expcontent
              if (key == "对照码") value = item.id
              if (this.printType == 95) {
                if (key == "生鲜") value = "√"
                if (key == "冷冻") value = "√"
              }

              LODOP.ADD_PRINT_TEXTA(this.printInfo.element[key].fieldname, this.printInfo.element[key].y, this.printInfo.element[key].x, this.printInfo.element[key].w, this.printInfo.element[key].h, value)/**增加纯文本打印项**/
            }
          }
        }
        this.loading = false
        if (LODOP.CVERSION) {
          CLODOP.On_Return = (TaskID, Value) => {
            if (Value >= 0) {
              LODOP.SET_PRINTER_INDEXA(Value)
              this.loading = true
              this.P_ID = LODOP.PRINT()//打印
              let endNo = this.printFormInline.endSerial
              location.hash = "idx" + endNo
              this.loading = false

              this.domSheetShow = true

            } else {
              MessageBox.alert('取消当前打印操作！', '系统提示', {
                confirmButtonText: '确定',
                type: 'warning'
              }).then(() => { }).catch(() => { })
              return false
            }
          }
          LODOP.SELECT_PRINTER()
          return false
        }

        if (LODOP.SELECT_PRINTER() >= 0) {
          LODOP.SET_PRINTER_INDEXA(LODOP.SELECT_PRINTER())
          this.loading = true
          this.P_ID = LODOP.PRINT()//打印
          let endNo = this.printFormInline.endSerial
          location.hash = "idx" + endNo
          this.loading = false
          this.domSheetShow = true

        } else {
          MessageBox.alert('取消当前打印操作！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
      },

      //关闭批量设置包裹数弹窗
      closePknumBox(val) {
        if (val) {
          if (this.packagenum < 1) {
            MessageBox.alert('请输入正确的包裹数！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning',
            }).then(() => { }).catch(() => { })
          } else {
            this.expcodeArr = []
            this.multipleSelection.forEach(item => {
              this.expcodeArr.push(item.expcode)
            })
            api.UPDATEPACKAGENUM({ packagenum: this.packagenum, expcode: this.expcodeArr }).then(res => {
              if (res.data.status == '200') {
                this.setPknumShow = false
                this.setStatus = false
                this.setPackageNum = false
                this.allSelect = false
                this.multipleSelection = []
                this.getPrintList()
              } else {
                MessageBox.alert(res.data.message, '系统提示', {
                  confirmButtonText: '确定',
                  type: 'warning',
                }).then(() => { }).catch(() => { })
              }
            })
          }
        } else {
          this.setPknumShow = false
          this.setStatus = false
          this.setPackageNum = false
        }
      },

      //关闭选择打印机弹窗
      closePrintBox(val) {
        if (val === 1) {
          if (!this.selectedPrint) {
            this.$message.error('请选择打印机！')
            return;
          }
          this.loadingCover = true; //打印加载中，勿动
          this.chosePrintLoding = true
          if (this.printType == '1') {
            this.printSfOfCloud();
          }
          //打印
          if (this.printType == '110') {
            this.doSetPrinterConfig(this.selectedPrint)
          }
          if (this.printType == '90') {
            this.jdsends()
          }
        }
        this.setPrintShow = false
        setTimeout(() => {
          this.chosePrintLoding = false
        }, 1000);
      },

      doSetPrinterConfig(printer) {
        this.doConnect()
        let request = this.getRequestObject(this.cnParams.cmd_setPrinterConfig)
        request.printer = {
          name: printer,
          needUpLogo: true,
          needDownLogo: false
        };
        this.cnParams.defaultPrinter = printer
        this.webSocket.send(JSON.stringify(request))
      },

      //关闭对照码弹窗
      closeDomSBox(val) {
        if (val) {
          if (this.referenceCode == '') {
            MessageBox.alert('请填写最后成功对照码！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning',
            }).then(() => { }).catch(() => { })
          } else {
            //完成打印
            this.finishParam = {
              startNo: this.printFormInline.startSerial,//起始序号
              endNo: this.printFormInline.endSerial,//结束序号
              printType: this.printType,//快递处理方式
              exptype: this.exptype,//快递方式，默认打印（针式打印）时必填
              dzm: this.referenceCode,//对照码，默认打印（针式打印）时必填
            }
            let expgenbatchnoArr = this.expgenbatchnoArr
            let params = {
              startNo: Number(this.printFormInline.startSerial),
              endNo: Number(this.printFormInline.endSerial),
              printType: this.printType,
              // taskValues: taskValues,
              expbatchno: expgenbatchnoArr.length == 1 ? expgenbatchnoArr[0] : '', //快递生成批次号
              // repeatmemo: this.repeatmemo,
            }
            api.ADDEXPPRINTBATCH(params).then(res => {
              if (res.data.status == '200') {
                //更改快递状态
                this.finishedPrint()
              } else {
                MessageBox.alert(res.data.message, '系统提示', {
                  confirmButtonText: '确定',
                  type: 'warning'
                }).then(() => {
                }).catch(() => {
                })
              }
            })
          }
        } else {
          MessageBox.confirm('确定取消本次操作', '确认提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.domSheetShow = false
          }).catch(() => { })
        }
      },

      //关闭重复打印弹窗
      closeAgainBox(val) {
        if (val == 1) {
          if (this.pwd == '') {
            MessageBox.alert('请填写登录密码！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning',
            }).then(() => { }).catch(() => { })
          } else if (this.repeatmemo == '') {
            MessageBox.alert('请填写重复打印备注！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning',
            }).then(() => { }).catch(() => { })
          } else {
            //验证登录密码
            api.CHECKUSERINFO({ pwd: this.pwd }).then(res => {
              if (res.data.status == '200') {
                //进行重复打印
                this.printAgainShow = false
                this.improveShow = true
              } else {
                MessageBox.alert(res.data.message, '系统提示', {
                  confirmButtonText: '确定',
                  type: 'warning',
                }).then(() => { }).catch(() => { })
              }
            })
          }
        } else {
          this.printAgainShow = false
        }
      },

      //关闭打印成功弹窗
      closeReferBox(val) {
        if (val == 1) {
          this.$router.push({
            name: '单号采集列表',
            params: {
              nonOddCollection: false, //是否展示快递方式
            }
          })
        } else {
          this.referSuccessVisible = false
          //当存在加入任务队列失败的快递时，提示
          if (this.finishParam.taskValues) {
            MessageBox.alert('注：如果经常出现此类问题，建议通过更换打印机的USB插口，或卸载打印插件重新安装，或卸载打印机驱动重新安装解决此类问题。',
              '系统提示', {
              confirmButtonText: '确定',
              type: 'warning',
            }).then(() => { }).catch(() => { })
          }
        }
      },
      //动态获取表格高度
      getHeight() {
        let tbHeight = this.$refs.expressTable.$el.offsetTop //顶部检索条件占据的高度
        this.tableHeight = window.innerHeight - tbHeight - 70
        //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      },

      //查看详情
      viewDetail(expcode) {
        this.expressDetailShow = true
        this.expcode = expcode
      },

      //获取批次快递详情
      getPrintList() {
        this.loading = true
        let params = {
          expgenbatchnoArr: this.expgenbatchnoArr,
          orderno: this.printFormInline.orderno,
          bprint: this.bprint,
          orderbytel: this.orderbytel,
          contentsort: this.contentsort,
          printType: this.printType,
        }
        api.FINDBATCHPRINT(params).then(res => {
          if (res.data.status == '200') {
            this.printListData = res.data.data.list
            this.printFormInline.endSerial = this.printListData.length
            this.expmerge = res.data.data.expmerge
            this.printconfig = res.data.data.config;
            if (this.printType == '107' && this.printconfig.config) {
              this.printconfig.config.forEach(res => {
                this.shopArray.push({ label: res.shopName, value: res.jdycconfig.shopId })
              })
            }
            if (this.printconfig && this.printconfig.sfexpresstype) {
              this.sfexpresstype = this.printconfig.sfexpresstype;
            }
            if (this.printconfig && this.printconfig.jdgoodstype) {
              this.jdgoodstype = this.printconfig.jdgoodstype;
            }
            if (this.printconfig && this.printconfig.promisetimetype) {
              this.promisetimetype = this.printconfig.promisetimetype;
            }
            if (this.printconfig && this.printconfig.defaultTemplate) {
              this.selectedJDTemplate = this.printconfig.defaultTemplate
            }
          } else {
            this.printListData = []
          }
          this.loading = false
        })
      },

      selectShop() {
        this.storesArr = []
        this.store = ''
        this.printconfig.config.forEach(res => {
          if (res.jdycconfig.shopId == this.entity) {
            res.jdycconfig.storesArr.forEach(item => {
              this.storesArr.push({ label: item.storeName, value: item.storeCode })
            })
          }
        })
      },

      //打印序号校验 type = 0 开始序号 type = 1 结束序号
      checkSerial(type) {
        if (type == 1) {
          if (!this.printFormInline.endSerial) {
            Message({
              type: 'error',
              message: '结束序号不能为空!'
            })
            this.printFormInline.endSerial = this.printListData.length
          }
          if (parseInt(this.printFormInline.endSerial) > this.printListData.length) {
            Message({
              type: 'error',
              message: '结束序号不能大于快递数量!'
            })
            this.printFormInline.endSerial = this.printListData.length
          }
          if (parseInt(this.printFormInline.endSerial) < parseInt(this.printFormInline.startSerial)) {
            Message({
              type: 'error',
              message: '结束序号不能小于开始序号!'
            })
            this.printFormInline.endSerial = this.printFormInline.startSerial
          }
        } else {
          if (!this.printFormInline.startSerial) {
            Message({
              type: 'error',
              message: '开始序号不能为空!'
            })
            this.printFormInline.startSerial = 1
          }
          if (parseInt(this.printFormInline.startSerial) > this.printListData.length) {
            Message({
              type: 'error',
              message: '开始序号不能大于快递数量!'
            })
            this.printFormInline.startSerial = 1
          }
          if (parseInt(this.printFormInline.startSerial) > parseInt(this.printFormInline.endSerial)) {
            Message({
              type: 'error',
              message: '开始序号不能大于结束序号!'
            })
            this.printFormInline.startSerial = 1
          }
        }
      },

      //选择菜鸟快递类型
      selectExpmode() {
        this.sendAddrList = []
        this.serviceList = []
        this.getCnAddr(this.printFormInline.expmodeofcn)
      },

      //选择服务
      selectServer() {
        let attrCodes = this.printFormInline.attrCode.split('#')
        this.attrTitle = attrCodes[3]
        this.attrNumber = false
        this.attrString = false
        this.attrOpt = false
        if (attrCodes[2] == 'number') {
          this.attrNumber = true
        } else if (attrCodes[2] == 'string') {
          this.attrString = true
        }
      },

      //获取填写的服务参数
      getAttrValue() {
        if (!this.printFormInline.attrCode || '' == this.printFormInline.attrCode) {
          return '';
        }
        let code = this.printFormInline.attrCode.split("#")[0];
        let attrMap = {};
        let valueMap = {};
        //金额
        if (this.printFormInline.attrCode.indexOf("#number") != -1) {
          valueMap["value"] = parseInt(this.printFormInline.attrNumber);
        }
        //枚举
        else if (this.printFormInline.attrCode.indexOf("#enum") != -1) {
          valueMap.set("value", this.printFormInline.attrEnum);
        }//字符串
        else if (this.printFormInline.attrCode.indexOf("#string") != -1) {
          valueMap.set("value", this.printFormInline.attrString);
        }
        attrMap[code] = valueMap;
        return JSON.stringify(attrMap);
      },

      //获取菜鸟寄件地址和服务列表
      getCnAddr(mark) {
        api.LISTCNADDR({ mark: mark }).then(res => {
          if (res.data.status == '200') {
            this.sendAddrList = res.data.data.list
            if (res.data.data.serverlist.length > 0) {
              res.data.data.serverlist.forEach(item => {
                this.serviceList.push({ value: item.value, label: item.key })
              })
            }
          } else {
            Message({
              type: 'error',
              message: res.data.message
            })
          }
        })
      },

      //获取面单类型
      listPricateinfo() {
        api.LISTPRICATEINFO().then(res => {
          if (res.data.status == '200') {
            this.expressWayList = res.data.data
          } else {
            this.expressWayList = []
          }
        })
      },

      //合并快递
      mergeExpress(type) {
        this.loading = true
        let params = {}
        //勾选
        if (type == 0) {
          //遍历已选中的快递
          this.expcodeArr = []
          this.multipleSelection.forEach(item => {
            this.expcodeArr.push(item.expcode)
          })
          params = { expcodeArr: this.expcodeArr }
        } else {//一键合并
          let map = {}
          this.multipleSelection.forEach(item => {
            let key = item.receivertel + item.addrdet;
            if (map[key]) {
              map[key] = map[key] + "," + item.expcode
            } else {
              map[key] = item.expcode
            }
          })
          let str = ''
          for (var key in map) {
            str += map[key] + '#'
          }
          params = { expMergeConcise: str.substring(0, str.lastIndexOf('#')) }
        }

        api.MERGEEXPRESS(params).then(res => {
          if (res.data.status == '200') {
            Message({
              type: 'success',
              message: '合并成功'
            })
            this.getPrintList()
            this.multipleSelection = []
          } else {
            Message({
              type: 'error',
              message: res.data.message
            })
          }
          this.loading = false
        })
      },

      disTable(row) {
        if (((row.merger == 1 && this.expmerge == 1) || (this.printconfig.sfbzmj == 1 && this.printType == '1' && this.setPackageNum) ||
          (this.printType == '90' && this.setPackageNum)) && !row.expno) {
          return true
        }
        return false
      },

      sourceChange: function (value, target) {
        this.printFormInline.printStatus = value ? [target.value] : []
        this.bprint = this.printFormInline.printStatus.length > 0 ? this.printFormInline.printStatus[0] : ''
        this.getPrintList()
      },

      //获取默认寄件方
      getDefSender() {
        api.GET_DEFSENDERINFO({ bdefault: 1 }).then(res => {
          if (res.data.status == '200') {
            this.senderInfo = res.data.data.length > 0 ? res.data.data[0] : ''
          }
        })
      },

      //获取菜鸟快递方式
      getExpmodeForCn() {
        api.LISTEXPMODEFORCN().then(res => {
          if (res.data.status == '200') {
            this.expmodelistOfCn = res.data.data
          }
        })
      },

      //完成打印
      finishedPrint(val) {
        api.FINISHEDPRINT(this.finishParam).then(res => {
          if (res.data.status == '200') {
            this.domSheetShow = false
            this.loadingCover = false; //打印加载中，勿动
            this.referSuccessVisible = true
            let value = val ? val : ''
            this.print_result = res.data.data.msg ? value + res.data.data.msg : "打印成功"
            this.getPrintList()
          } else {
            Message({
              type: 'error',
              message: '打印失败，请刷新重试！'
            })
          }
        })
      },

      //韵达热敏初始化
      ydPrintInit() {
        this.loading = true
        api.YDPRINTINIT({ startNo: this.printFormInline.startSerial, endNo: this.printFormInline.endSerial }).then(res => {
          if (res.data.status == '200') {
            this.ydPrintData = res.data.data
            //请求韵达服务
            axios.post('http://127.0.0.1:9090/ydecx/service/mailpx/printDirect.pdf?tname=mailtmp_s12&docname=mailpdfm1&t=' + new Date().getTime(),
              { value: '' }).then((response) => {
                console.log(response);
                this.improveShow = true
                this.loading = false
              }).catch((error) => {
                console.log(error);
                MessageBox.alert('请安装韵达打印控件！', '系统提示', {
                  confirmButtonText: '确定',
                  type: 'warning',
                }).then(() => { }).catch(() => { })
                this.loading = false
              });
          } else {
            MessageBox.alert(res.data.message, '系统提示', {
              confirmButtonText: '确定',
              type: 'warning',
            }).then(() => { }).catch(() => { })
            return false
          }
        })
      },

      //热敏打印
      subPrint() {
        if (this.printType == '110' && (this.printFormInline.expmodeofcn === '' || this.printFormInline.expmodeofcn == null)) {
          this.$message.error('快递方式不能为空！')
          return false
        }
        const LODOP = getLodop()
        //序号校验
        if (!this.validateStartEnd()) {
          return false
        }
        let startNo = this.printFormInline.startSerial
        let endNo = this.printFormInline.endSerial
        //已打印数量
        let count = 0
        //已筛单数量
        let screennum = 0
        //遍历快递列表
        this.printListData.forEach((item, index) => {
          if ((index + 1) >= startNo && (index + 1) <= endNo && item.expno != null && item.expno != "" && item.bprint == 1) {
            count++
          }
          if ((index + 1) >= startNo && (index + 1) <= endNo && item.expno != null && item.expno != "" && item.screenstate == 1) {
            screennum++
          }
        })
        if (screennum == 0) {
          MessageBox.alert('暂无筛单成功的快递，请下单后再打印！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => { }).catch(() => { })
          return false
        }
        //重复打印输入密码
        if (count > 0) {
          //密码验证弹窗
          console.log('第二次打印')
          this.printAgainShow = true
        } else {
          MessageBox.confirm('您确定打印吗？', '确认提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //初始化韵达热敏
            if (this.printType == '79') {
              this.ydPrintInit()
            } else {
              this.improveShow = true
            }
          }).catch(() => { })
        }
      },

      /************************************************顺丰云打印 2022-06-29 李某人 *******************************************************/
      getSfToken() {
        api.GET_SF_TOKEN().then(res => {
          if (res.data.status == '200') {
            this.sftoken = res.data.data
          }
        })
      },
      initSFCloud() {
        if (!this.printSdk) {
          const sdkCallback = (result) => {
            console.log(result, 3)
          };
          const sdkParams = {
            //"env": "sbox", //沙箱环境
            "env": "pro", //生产环境
            "partnerID": this.checkcode,
            "callback": sdkCallback,
            "notips": false
          };
          this.printSdk = new SCPPrint(sdkParams);
          // 不设置打印机则使用默认打印机，如需设置可使用如下getPrinters和setPrinter方法
          // 获取打印机列表
          const getPrintersCallback = (result) => {
            if (result.code === 1) {
              this.printers = result.printers;
            }
            this.printList = []
            for (let i = 0; i < this.printers.length; i++) {
              this.printList.push({ label: this.printers[i].name, value: this.printers[i].name })
            }
          };
          this.printSdk.getPrinters(getPrintersCallback);
          //获取sftoken授权
          this.getSfToken();
        }
        this.setPrintShow = true
      },
      printSfOfCloud() {
        // 选择打印机后设置打印机
        this.printSdk.setPrinter(this.selectedPrint);
        //获取打印单号
        let documents = []
        let startNo = this.printFormInline.startSerial
        let endNo = this.printFormInline.endSerial
        let sfprintpagetype = this.printconfig.sfprintpagetype

        if (sfprintpagetype == "") {
          sfprintpagetype = 2
        }
        let templateCode = sfprintpagetype == 3 ? 'fm_180_standard_'
          : sfprintpagetype == 4 ? 'fm_210_standard_'
            : sfprintpagetype == 5 ? 'fm_76130_standard_'
              : sfprintpagetype == 6 ? 'fm_150_international_'
                : sfprintpagetype == 7 ? 'fm_210_international_'
                  : sfprintpagetype == 8 ? 'fm_76130_standard_'
                    : sfprintpagetype == 9 ? 'fm_150_standard_'
                      : sfprintpagetype == 10 ? 'fm_180_standard_'
                        : sfprintpagetype == 11 ? 'fm_210_standard_'
                          : 'fm_150_standard_'
        let customTemplateCode = sfprintpagetype == 8 ? 'fm_76130_standard_custom_10000740991_7'
          : sfprintpagetype == 9 ? 'fm_150_standard_custom_10012599174_1'
            : sfprintpagetype == 10 ? 'fm_180_standard_custom_10012601834_1'
              : sfprintpagetype == 11 ? 'fm_210_standard_custom_10012602817_2'
                : null
        let idx
        let expno
        let screenstate
        let content = {}
        let isPrintLogo = this.printconfig.isPrintLogo === 1 ? 'true' : ''
        let tel
        this.printListData.forEach((item, index) => {
          tel = item.receivertel ? item.receivertel : item.othtel
          tel = tel.substring(tel.length - 6, tel.length)
          content = item.content
          idx = index + 1
          expno = item.expno
          screenstate = item.screenstate

          let meno = '' // 最终打印备注
          let tmpsellermemo = ''
          let tmp_length = (item.sellermemo ? item.sellermemo.length : 0) + (this.printconfig.printmemo ? this.printconfig.printmemo.length : 0)
          if (tmp_length > 40) {
            tmpsellermemo = item.sellermemo.substring(0, (40 - (this.printconfig.printmemo ? this.printconfig.printmemo.length : 0) - 4)) + '...'
          } else {
            tmpsellermemo = item.sellermemo ? item.sellermemo : ''
          }
          // printmemo 统一打印备注，传入
          meno = tmpsellermemo + ' ' + (this.printconfig.printmemo ? this.printconfig.printmemo : '')

          if (idx >= startNo && idx <= endNo && expno != null && expno != "" && screenstate == 1) {
            documents.push({
              "masterWaybillNo": expno,
              "isPrintLogo": isPrintLogo,
              "remark": meno,
              "waybillNoCheckType": "1",
              "waybillNoCheckValue": tel,
              "customData": customTemplateCode ? { 'cargoDetails': item.expcontent, 'memo': meno } : null
            })
            if (content.childno) {
              let childnos = content.childno.split(',')
              childnos.forEach((item, index) => {
                documents.push({
                  "masterWaybillNo": expno,
                  "branchWaybillNo": item,
                  "seq": index + 2 + "",
                  "sum": childnos.length + 1 + "",
                  "isPrintLogo": isPrintLogo,
                  "remark": meno,
                  "waybillNoCheckType": "1",
                  "waybillNoCheckValue": tel
                })
              })
            }
            if (content.backno) {
              documents.push({
                "masterWaybillNo": expno,
                "backWaybillNo": content.backno,
                "isPrintLogo": isPrintLogo,
                "remark": meno,
                "waybillNoCheckType": "1",
                "waybillNoCheckValue": tel
              })
            }
          }
        });
        // 调用打印方法
        const data = {
          "requestID": this.getUUID(),
          "accessToken": this.sftoken,
          "templateCode": templateCode + this.checkcode,
          "customTemplateCode": customTemplateCode,
          "documents": documents
        };
        const printCallback = (result) => {
          if (result.code === 1) {
            this.addExpprintBatch(startNo, endNo, this.repeatmemo, "")
          }
        };
        const options = {
          "lodopFn": "PRINT" // 默认打印，预览传PREVIEW
        };
        this.printSdk.print(data, printCallback, options);
        this.loading = true
      },

      /*********京东云打印 2022-06-30 李某人*********/
      closeJDBox() {
        this.tipJDMsg = false
      },
      jdconnect() {
        if (!this.jdWebSocket) {
          try {
            //链接路径
            const host = "ws://localhost:9113";
            this.jdWebSocket = new WebSocket(host);
            this.jdWebSocket.onopen = () => {
              console.log('this.jdWebSocket', 'onopen')
              //打印机列表
              const text = "{\"orderType\":\"GET_Printers\",\"pin\":\"用户名\",\"parameters\":{		\"tempUrl\":\"\",		\"printName\":\"\",		\"printData\":\"\"	}}";
              this.jdWebSocket.send(text);
              //获取京东打印模板
              this.getJdTemplateList()
            }
            this.jdWebSocket.onmessage = (msg) => {
              const returnData = msg.data;
              console.log(returnData)
              //返回信息
              const json = eval('(' + returnData + ')');
              const content = json.content;
              //打印机列表
              if (json.code == "6") {
                const ps = content.split(",");
                ps.forEach(item => {
                  this.printList.push({ label: item, value: item })
                });
              } else if (json.code == '2') {
                if (json.success == 'true') {
                  this.jdsuccessnum++
                  if (this.jdallnum === this.jdsuccessnum) {
                    this.addExpprintBatch(this.printFormInline.startSerial, this.printFormInline.endSerial, this.repeatmemo, "")
                    console.log('京东打印成功！')
                  }
                }
              } else if (json.code == "8") {

              } else {

              }
            }
            this.jdWebSocket.onclose = () => {
              this.tipJDMsg = true
              console.log('this.jdWebSocket', '123')
            }
          } catch (exception) {
            console.log('this.jdWebSocket', 'error')
          }
        }
        this.setPrintShow = true
      },
      getJdTemplateList() {
        this.jdTemplateList = []
        api.GET_JD_TEMPLATELIST().then(res => {
          if (res.data.status == '200') {
            if (res.data.data.templates) {
              this.jdcpcodes = new Map()
              res.data.data.templates.forEach(item => {
                this.jdTemplateList.push({ label: item.name, value: item.value })
                this.jdcpcodes.set(item.value, item.cpcode)
              });
            }
          }
        })
      },
      getJdPrintData(expnos) {
        let cpcode = this.jdcpcodes ? this.jdcpcodes.get(this.selectedJDTemplate) : 'JD'
        api.GET_JD_PRINTDATA({ "codes": expnos, "cpcode": cpcode }).then(res => {
          if (res.data.status == '200') {
            res.data.data.forEach(item => {
              this.jdsend(item.perPrintData)
            })
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      subJdOrderOfVirtual(expcode) {
        api.SUB_JD_ORDER_VIRTUAL({ 'expcode': expcode }).then(res => {
          if (res.data.status == '200') {
            this.$message.success('模拟下单成功！')
            this.getPrintList()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      jdsends() {
        if (!this.selectedJDTemplate) {
          this.$message.error('请选择面单！')
          return;
        }
        //构造打印数据
        let startNo = parseInt(this.printFormInline.startSerial)
        let endNo = parseInt(this.printFormInline.endSerial)
        let idx
        let expno
        let screenstate
        let expnoArray = []
        let expnoParam = ''
        this.jdallnum = 0
        this.jdsuccessnum = 0
        this.printListData.forEach((item, index) => {
          idx = index + 1
          expno = item.expno
          screenstate = item.screenstate
          if (idx >= startNo && idx <= endNo && expno != null && expno != "" && screenstate == 1) {
            this.jdallnum++
            expnoParam += expno + ','
            if (idx % 10 == 0) {
              expnoArray.push(expnoParam.substring(0, expnoParam.lastIndexOf(',')))
              expnoParam = ''
            }
            if (idx === endNo) {
              expnoArray.push(expnoParam.substring(0, expnoParam.lastIndexOf(',')))
              expnoParam = ''
            }
          }
        });
        expnoArray.forEach(array => {
          if (this.jdprinttest) {
            this.jdsend("9XR7FEUvv/J9BWiMc02qM8IBW3f+j592F4nskdvvGT1CPqnNoA8akhHJxTQExN4m0hAsUthn6f8ajWgxZiW34zmPz0i4dQKkmJ34vM+x+wTWLlBhLbjvljZnxHT2bLwXwppTwMqKV+VX6yvIaJD8AG2Jo3cEvpIT8Ol7bbt6Xwz5gPtTKtNiug7WJH+fUO9RCsffQB24m+x1QkwuDFCjOxMtacZxHVrF3ECX9EUh6/Hq4e5jlIz70S/exGLFDAl26X/5SpUSZzVqFJeJzbUQWoiZFTdCWoDQTuBpkwFbezCdYC5o9bYtGIbOd6LBpHDrp+sSgrjU84uxGD9n+DO2NsqHzDDaVANcYpbnxBeJcbSuVolWlG8MzktoD6/BfqNRBFKLQF4TRg/QdlP3FTc5sNVKLBLNyOWT/R1IfWqV0qOLxhkxztEBbVlIUY7O6xXkjPWnh8VUlDwLBwpA8JmGvWKEs3w9L49tqErA/GxX9IoAuBfBQgQf60ALvOI2FcTvg/rUlk7BxcRQDlBTza2qTjNwdSlBukERm+cWldOVLVC5qADOidiEZttshGnm4F+2gVttyNo7rwTVv5HQE281xLHqowBfwMCM4aAgZ3q99WJ4ficC8AnDwyolFr99DNZeLeyAx3vF4SjYWdleNfLuNNKogroiX0yjmx4RIlUfBPx6XDhSb4ejz1StzOtFjREDii6zFv5i6LnnlkOpK2P7g3+mC7TYs4RLgfMB3wDb7wdySE5ejm+oeXmvyZH3rlsJXpamyRIUanIWi0v/4bloPLiIE0bKJh0E/R1uU9UQA8NE8Y9AxTbXZvqswgBB28ArfMsPTuTjHFRn8KJpcNyo1W3togL7UEoRU70nH0iTH/MxVsj0Sr1/6FyGcLRRc50uOwqLOfSvr0cfYNwUPy/CDW3cStSQxt3i/lKItXfTDWeBPTmOsREGJVS2stkiAe+O5nIAw+rDbC+MF4BUjkcDLgp6+Csjvjgisf/9e2ESurOD5GqGn7+VGOiBxRkmtZklwd4BsjUkKZ03oyrS+cJvAHo/2ci/wwps9n1EcNb3cVHekujmdQ5hAIYAVY85/GAhRfswB4gaMg5IKjambDngDdalhkHaEFlwiScu1Uu/S2riqNrCnCBuqf2UkuFwvFAtpsON6UCPgGZ+cejUG2yRTmNiEOUxJ/xrqfiMFTalpAhSwVRn86/373ym5rE+VI2jp7xtiQ3A39JnzmDgRPkWwYad1L/2PneDI88wRUJERCx42y/Z6p1N4Oi8KPZmm6w0S3294rgY015Q0DIXfT3Cb5UhtIAObIr1BWdCn8didddZJsDaxr8sT7aNKNjmQ0PRKQmLLyH9B9cdELBqYxoacZAY7x4Z8KCHV6GGgWdPU0D49rrQzKFHu3VvieWK1z1QGJI/VNLRI3ahJ4JfR+PWRRedVJB3Tm2ICjHZmGludQPp9Gj9Kxg6+1ervsi8svbtCdvtZwm5sc2UcwwM/nN48+YJeAx4nu/LfKge8sM3qKmfWiOC2hhxjIvYDf899gvSQRLng37wcqp/MUB5j1OWzm4gimSJNVAnyz7f00VTF2R1IaNqN0G1xNDBxmgQL6YPiwflzymt+nnsXVAILpTA6w==")
          } else {
            this.getJdPrintData(array)
          }
        })
      },
      /**
       * 发送打印数据
       */
      jdsend(printData) {
        //1、打印数据 printData
        //2、打印模版
        let temp = this.selectedJDTemplate;
        //3、打印自定义模版
        let tempUser = '';
        //3、打印自定义数据
        let printDataUser = '';
        try {
          //1、打印指令
          // let printCmd = "PRE_View";
          let printCmd = "print";
          //2、打印机名称
          let printName = this.selectedPrint;
          let text = "{\"orderType\": \"" + printCmd + "\", \"parameters\": {\"printName\": \"" + printName + "\", 		\"tempUrl\": \"" + temp + "\", \"customTempUrl\": \"" + tempUser + "\", \"customData\": [" + printDataUser + "], 	\"printData\": [\"" + printData + "\"] } }";
          this.jdWebSocket.send(text);
        } catch (exception) {
          console.log('error', exception)
        }
      },
      jdPrintOfVirtual() {
        this.jdprinttest = true
        this.selectedJDTemplate = 'https://template-content.jd.com/template-content?type=standards&id=100101';
        this.subPrint()
      },
    },
    created() {
      //页面浏览器视窗变化绑定resize事件
      window.addEventListener("resize", this.getHeight)
    },
    mounted() {
      if (localStorage.getItem('userInfoMd')) {
        this.qydm = JSON.parse(localStorage.getItem('userInfoMd')).qydm;
      }
      if (this.$route.params.printType) {
        this.printType = this.$route.params.printType
      }
      // 是否为重置待发批次 1为是
      if (this.$route.query.breturn) {
        this.breturn = this.$route.query.breturn
      }
      if (sessionStorage.getItem('expgenbatchnoArr')) {
        this.expgenbatchnoArr = JSON.parse(sessionStorage.getItem('expgenbatchnoArr'))
      }
      //在dom渲染之后
      setTimeout(() => {
        //状态选择初始化
        if (this.printType == 1000) {
          this.PrintStatusLists = [
            { label: "待打印", value: 0 },
            { label: "已打印", value: 1 }
          ]
        } else {
          this.PrintStatusLists = [
            { label: "待下单", value: 2 },
            { label: "筛单成功可打印", value: 3 },
            { label: "筛单失败", value: 4 },
            { label: "已打印", value: 1 }
          ]
        }
        this.getHeight()
        this.getPrintList()
        if (this.printType == 1000) {
          this.listPricateinfo()
        }
        if (this.printType == '110') {
          this.getExpmodeForCn()
        }
        this.getDefSender()
        if (this.printType == '110') {
          this.doConnect()
        }
      }, 200);
      // 查询产品类型
      this.getExpressTypeList();
    },
    destroyed() {
      window.removeEventListener("resize", this.getHeight) //销毁监听浏览器视窗变化
    }
  }
</script>

<style scoped>
  @import "Css/Style.css";

  .serialIpt .el-input {
    width: 100px;
  }

  .serialIpt i {
    padding: 0 5px;
  }

  .iconwh {
    font-size: 16px;
    color: #ccc;
    margin-left: 5px;
    margin-right: 20px;
    cursor: pointer;
  }

  /*选择寄件方*/
  .senderMdg>>>.el-dialog {
    width: 700px;
  }

  .senderMdg>>>.el-form-item__content {
    width: 65%;
    min-width: 200px;
    max-width: 340px;
  }

  .senderMdg>>>.el-form-item__content .el-select {
    width: 100%;
  }

  /*对照码弹窗 start*/
  .referMdg>>>.el-dialog {
    width: 600px;
  }

  .referMdg>>>.el-form-item__content {
    width: 65%;
    min-width: 200px;
    max-width: 340px;
  }

  .referMdg>>>.el-form p {
    padding-left: 30px;
    line-height: 40px;
  }

  .referMdg .iconwh {
    position: absolute;
    right: -50px;
  }

  .referSuccess>>>.el-dialog {
    width: 420px;
  }

  .referSuccess>>>.el-dialog__footer {
    box-shadow: none;
    margin-bottom: 5px;
  }

  .referSuccess>>>.el-button {
    padding: 8px 15px;
  }

  .referSuccess>>>.el-dialog__body {
    padding: 13px 20px 11px 120px;
  }

  .referMain .el-icon-success {
    font-size: 24px;
    color: #67c23a;
    padding-right: 15px;
  }

  /*对照码弹窗 end*/

  /*菜鸟打印提示*/
  .cnDlog>>>.el-dialog {
    width: 420px;
  }

  .cnDlog p {
    padding-bottom: 15px;
    color: #666;
    line-height: 25px;
    text-align: center;
  }

  .cnDlog p:before {
    font-size: 24px;
    color: #F2962C;
    padding-right: 15px;
  }

  .cnDlog p,
  .cnDlog .el-link {
    display: block;
    text-align: center;
  }

  .cnDlog>>>.el-dialog__footer {
    box-shadow: none;
    margin-bottom: 5px;
  }

  @media (max-width: 1000px) {
    .individualiz>>>.el-form .el-input {
      width: 150px;
    }

    .individualiz>>>.el-form .el-checkbox {
      margin-right: 15px;
    }
  }

  .hideLable.el-checkbox-group>>>.el-checkbox__label {
    display: none;
  }

  /*选择上门取件时间 start */
  .el-icon-date.fz20 {
    font-size: 20px !important;
  }

  .panelTit span {
    flex: 1;
    max-width: calc(33.33% - 3px);
    padding: 5px 0;
    line-height: 1.3;
    background: #F5F7FA;
    text-align: center;
    cursor: pointer;
  }

  .panelTit .on {
    background: var(--main-color);
    color: #fff;
  }

  .panelUBox {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .panelUBox li {
    flex: 0 0 33.3333%;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }

  .panelUBox li:hover,
  .panelUBox li.on {
    background: #ECF5FF;
  }

  .panelUBox li.on {
    color: var(--main-color);
  }

  /*选择上门取件时间 end */

  /*打印勿动遮罩 start */
  .tipDescription {
    background: rgba(255, 255, 255, .8);
  }

  .tipDescription>>>.el-dialog__body {
    height: 60% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .tipDescription p {
    font-size: 28px;
    color: #FA2F2F;
    line-height: 70px;
  }

  /*打印勿动遮罩 end */
</style>
<style>
  .calendarPnl {
    padding: 5px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/DeliveryFolder/TypePrintingList.vue